<template>
  <div class="create-earning-item wrapper">
    <el-container>
      <el-header>
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="first">
            <div class="form-wrapper">
              <el-form
                :model="formData"
                :inline="true"
                label-width="150px"
                style="margin-top: 16px"
                :rules="rules1"
                ref="formRef1"
              >
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="项目部" prop="deptId">
                      <el-select
                        :value="formData.deptId"
                        clearable
                        placeholder=""
                        readonly
                      >
                        <el-option
                          v-for="dept in deptListForSelect"
                          :key="dept.applyDeptId"
                          :label="dept.applyDeptName"
                          :value="dept.applyDeptId"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="项目名称" prop="projectId">
                      <el-select
                        :value="formData.projectId"
                        placeholder=""
                        readonly
                      >
                        <el-option
                          v-for="project in projectListForSelect"
                          :key="project.id"
                          :label="project.name"
                          :value="project.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="项目所属年度">
                      <el-input
                        :value="
                          receiptsEarningCost
                            ? receiptsEarningCost.belongYear
                            : ''
                        "
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="工程进度">
                      <el-input
                        :value="
                          receiptsEarningCost
                            ? receiptsEarningCost.processStatusDisplayName
                            : ''
                        "
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="合同金额">
                      <el-input
                        :value="
                          receiptsEarningCost
                            ? formatMoneyNumber(
                                receiptsEarningCost.contractPrice
                              )
                            : ''
                        "
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="已完成工作量">
                      <el-input
                        :value="
                          receiptsEarningCost
                            ? receiptsEarningCost.finishPriceSum
                            : ''
                        "
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="上报计量">
                      <el-input
                        :value="
                          receiptsEarningCost
                            ? receiptsEarningCost.calculatePriceSum
                            : ''
                        "
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="已收计量金额">
                      <el-input
                        :value="
                          receiptsEarningCost
                            ? formatMoneyNumber(
                                receiptsEarningCost.receiptPriceSum
                              )
                            : ''
                        "
                        readonly
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="收集团拨款金额">
                      <el-input
                        :value="formatMoneyNumber(groupAmount)"
                        readonly
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="贷款利率(%)" prop="loanPct">
                      <el-input-number
                        v-model="formData.loanPct"
                        @change="loanPctBlur"
                        :precision="2"
                        :min="0"
                        :max="9999999999999"
                        controls-position="right"
                        clearable
                        placeholder="请输入"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="资金成本">
                      <el-input
                        :value="formatMoneyNumber(capitalCost)"
                        readonly
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="预计可实现收入" prop="expectIncomePct">
                      <el-input-number
                        v-model="formData.expectIncomePct"
                        :precision="2"
                        :min="0"
                        :max="9999999999999"
                        controls-position="right"
                        clearable
                        placeholder="请输入"
                      ></el-input-number>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>

            <!-- 跟工程成本明细表很像的表格 -->
            <div class="table-wrapper">
              <el-table
                :data="tableData"
                border
                style="width: 100%"
                height="600"
                :span-method="spanArrayMethod"
              >
                <el-table-column
                  prop="title"
                  label="项目"
                  width="70"
                  fixed
                ></el-table-column>
                <el-table-column
                  label="序号"
                  prop="myindex"
                  fixed
                  width="46"
                ></el-table-column>
                <el-table-column
                  label="合作单位"
                  width="100"
                  prop="partyB"
                ></el-table-column>
                <el-table-column
                  label="合同编号"
                  width="100"
                  prop="serialNumber"
                ></el-table-column>
                <el-table-column
                  label="合同金额（含税）"
                  width="100"
                  prop="amount"
                ></el-table-column>
                <el-table-column
                  label="合同内容"
                  width="120"
                  prop="contractContent"
                ></el-table-column>
                <el-table-column label="税后合价" width="100">
                  <template slot-scope="scope">
                    <div>{{ formatMoneyNumber(scope.row.settleAmount) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="裸税合价" width="100">
                  <template slot-scope="scope">
                    <div>{{ formatMoneyNumber(scope.row.cost) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="开具发票">
                  <el-table-column label="含税金额" width="100">
                    <template slot-scope="scope">
                      <div>
                        {{ formatMoneyNumber(scope.row.taxBillAmount) }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="不含税金额" width="100">
                    <template slot-scope="scope">
                      <div>
                        {{ formatMoneyNumber(scope.row.noTaxBillAmount) }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column label="未开具发票">
                  <el-table-column label="含税金额" width="100">
                    <template slot-scope="scope">
                      <div>
                        {{ formatMoneyNumber(scope.row.taxNoBillAmount) }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="暂行税率" width="100">
                    <template slot-scope="scope">
                      <div v-if="!!scope.row.hideTaxRateCurrent == false">
                        {{ formatPercentNumber(scope.row.taxRateCurrent) }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="不含税金额" width="100">
                    <template slot-scope="scope">
                      <div>
                        {{ formatMoneyNumber(scope.row.noTaxNoBillAmount) }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column label="累计已付款" width="100">
                  <template slot-scope="scope">
                    <div>{{ formatMoneyNumber(scope.row.alreadyPay) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="尚欠款" width="100">
                  <template slot-scope="scope">
                    <div>{{ formatMoneyNumber(scope.row.debtAmount) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="已付款比例" width="100">
                  <template slot-scope="scope">
                    <div>
                      {{ formatPercentNumber(scope.row.alreadyPayPct) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="本次拟付款" width="100">
                  <template slot-scope="scope">
                    <div>{{ formatMoneyNumber(scope.row.thisPay) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="再付款比例" width="100">
                  <template slot-scope="scope">
                    <div>{{ formatPercentNumber(scope.row.thisPayPct) }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="备注"
                  prop="remark"
                  width="100"
                ></el-table-column>
                <el-table-column label="操作" width="140" fixed="right">
                  <template slot-scope="scope">
                    <div v-if="scope.row.handler && scope.row.multi">
                      <el-button type="text" @click.stop="addItem(scope.row)"
                        >添加</el-button
                      >
                      <el-button type="text" @click.stop="editItem(scope.row)"
                        >编辑</el-button
                      >
                      <el-button type="text" @click.stop="deleteItem(scope.row)"
                        >删除</el-button
                      >
                    </div>
                    <div v-else-if="scope.row.handler && !scope.row.multi">
                      <el-button type="text" @click.stop="editItem(scope.row)"
                        >编辑</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 跟收支明细表很像的表格 -->
            <div class="table-wrapper">
              <el-table
                :data="tableData2"
                border
                style="width: 100%"
                height="600"
                :span-method="spanArrayMethod2"
              >
                <el-table-column
                  prop="myindex"
                  label="序号"
                  width="50"
                ></el-table-column>
                <el-table-column label="工程明细情况">
                  <el-table-column prop="title1"></el-table-column>
                  <el-table-column prop="title2"></el-table-column>
                </el-table-column>
                <el-table-column label="合同金额" width="200">
                  <template slot-scope="scope">
                    <div>{{ formatMoneyNumber(scope.row.contractAmount) }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="预算金额">
                  <el-table-column
                    label="含税金额"
                    prop="budgetTaxAmount"
                    width="220"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.budgetTaxAmountInput">
                        <el-input-number
                          :value="scope.row.budgetTaxAmount"
                          controls-position="right"
                          clearable
                          :min="0"
                          :max="9999999999999"
                          :precision="2"
                          placeholder="请输入"
                          @change="
                            (value) =>
                              budgetTaxAmountChange(
                                value,
                                scope.row.budgetTaxAmountName
                              )
                          "
                        ></el-input-number>
                      </div>
                      <div v-else-if="scope.row.budgetTaxAmountShowNum">
                        {{ formatMoneyNumber(scope.row.budgetTaxAmount) }}
                      </div>
                      <div v-else-if="scope.row.budgetTaxAmountShowPct">
                        {{ formatPercentNumber(scope.row.budgetTaxAmount) }}
                      </div>
                      <div v-else>
                        <!-- 不显示 -->
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="不含税金额" prop="budgetNoTaxAmount">
                    <template slot-scope="scope">
                      <div v-if="scope.row.budgetNoTaxAmountShowNum">
                        {{ formatMoneyNumber(scope.row.budgetNoTaxAmount) }}
                      </div>
                      <div v-else-if="scope.row.budgetNoTaxAmountShowPct">
                        {{ formatPercentNumber(scope.row.budgetNoTaxAmount) }}
                      </div>
                      <div v-else-if="scope.row.budgetNoTaxAmountInput">
                        <el-input-number
                          :value="scope.row.budgetNoTaxAmount"
                          controls-position="right"
                          clearable
                          :min="0"
                          :max="9999999999999"
                          :precision="2"
                          placeholder="请输入"
                          @change="
                            (value) =>
                              budgetNoTaxAmountChange(
                                value,
                                scope.row.budgetNoTaxAmountName
                              )
                          "
                        ></el-input-number>
                      </div>
                      <div v-else>
                        <!-- 不显示 -->
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column label="实际发生金额">
                  <el-table-column
                    label="含税金额"
                    prop="actTaxAmount"
                    width="220"
                  >
                    <template slot-scope="scope">
                      <!-- 如果是 actTaxAmountInput ，则这里是个input -->
                      <!-- 如果是 actTaxAmountShowNum ，则这里展示数字 -->
                      <!-- 如果是 actTaxAmountShowPct ，则这里展示百分比 -->
                      <!-- 其他，则此处什么也不显示 -->
                      <div v-if="scope.row.actTaxAmountInput">
                        <el-input-number
                          :value="scope.row.actTaxAmount"
                          controls-position="right"
                          clearable
                          :min="0"
                          :max="9999999999999"
                          :precision="2"
                          placeholder="请输入"
                          @change="
                            (value) =>
                              actTaxAmountChange(
                                value,
                                scope.row.actTaxAmountName
                              )
                          "
                        ></el-input-number>
                      </div>
                      <div v-else-if="scope.row.actTaxAmountShowNum">
                        {{ formatMoneyNumber(scope.row.actTaxAmount) }}
                      </div>
                      <div v-else-if="scope.row.actTaxAmountShowPct">
                        {{ formatPercentNumber(scope.row.actTaxAmount) }}
                      </div>
                      <div v-else>
                        <!-- 不显示 -->
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="不含税金额" prop="actNoTaxAmount">
                    <template slot-scope="scope">
                      <div v-if="scope.row.actNoTaxAmountShowNum">
                        {{ formatMoneyNumber(scope.row.actNoTaxAmount) }}
                      </div>
                      <div v-else-if="scope.row.actNoTaxAmountShowPct">
                        {{ formatPercentNumber(scope.row.actNoTaxAmount) }}
                      </div>
                      <div v-else-if="scope.row.actNoTaxAmountInput">
                        <el-input-number
                          :value="scope.row.actNoTaxAmount"
                          controls-position="right"
                          clearable
                          :min="0"
                          :max="9999999999999"
                          :precision="2"
                          placeholder="请输入"
                          @change="
                            (value) =>
                              actNoTaxAmountChange(
                                value,
                                scope.row.actNoTaxAmountName
                              )
                          "
                        ></el-input-number>
                      </div>
                      <div v-else>
                        <!-- 不显示 -->
                      </div>
                    </template>
                  </el-table-column>
                </el-table-column>
                <el-table-column label="备注" prop="remark"></el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="审批流程" name="second" style="min-height: 500px">
            <approveLine
            :addoredit="false"
            :itemId="id || 0"
            :approveType="approveType"
            :approveClass="approveClass"
            @saveApproveLine="saveApproveLine"
          ></approveLine>
          </el-tab-pane>
          <div style="text-align: center; margin: 16px auto">
            <el-button type="primary" @click.stop="submitData(true)"
              >暂存</el-button
            >
            <el-button type="primary" @click.stop="submitData(false)">提交</el-button>
            <el-button type="info" @click="closePage">取消</el-button>
          </div>
        </el-tabs>
      </el-header>
    </el-container>

    <el-dialog title="添加" :visible.sync="addItemDialogVisible">
      <el-form
        ref="addFormRef"
        label-position="left"
        :model="addItemDialogData"
        label-width="200px"
        :rules="rules2"
      >
        <el-form-item label="合作单位" prop="partyBId">
          <el-select
            v-model="addItemDialogData.partyBId"
            placeholder="请选择"
            @change="partyBAddChange"
          >
            <el-option
              v-for="(item, index) in partyBToSelect"
              :key="'partyB__' + index"
              :label="item.partyB"
              :value="item.partyBId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同内容" prop="contractContent">
          <el-select
            v-model="addItemDialogData.contractContent"
            placeholder="请选择"
            @change="contractContentAddChange"
          >
            <el-option
              v-for="(item, index) in contentToSelect"
              :key="'content__' + index"
              :label="item.content"
              :value="item.content"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同编号">
          <el-input
            :value="addItemDialogData.serialNumber"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同金额（含税）">
          <el-input
            v-model="addItemDialogData.amount"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="税后合价" prop="settleAmount">
          <el-input-number
            v-model="addItemDialogData.settleAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="taxBillAmountAddChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="裸税合价" prop="cost">
          <el-input-number
            v-model="addItemDialogData.cost"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="costAddChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="开具发票（含税金额）" prop="taxBillAmount">
          <el-input-number
            v-model="addItemDialogData.taxBillAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="taxBillAmountAddChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="开具发票（不含税金额）">
          <el-input-number
            v-model="addItemDialogData.noTaxBillAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            :disabled="true"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="未开具发票（含税金额）">
          <el-input-number
            v-model="addItemDialogData.taxNoBillAmount"
            controls-position="right"
            clearable
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            :disabled="true"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="未开具发票（暂行税率）[%]" prop="taxRateCurrent">
          <el-input-number
            v-model="addItemDialogData.taxRateCurrent"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="taxRateCurrentAddChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="未开具发票（不含税金额）">
          <el-input-number
            v-model="addItemDialogData.noTaxNoBillAmount"
            controls-position="right"
            clearable
            :max="9999999999999"
            :precision="2"
            placeholder=""
            :disabled="true"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="累计已付款">
          <el-input-number
            v-model="addItemDialogData.alreadyPay"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="本次拟付款">
          <el-input-number
            v-model="addItemDialogData.thisPay"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="addItemDialogData.remark"
            placeholder="请输入"
            clearable
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="info" @click.stop="cancelAddItem">取消</el-button>
        <el-button type="primary" @click.stop="confirmAddItem">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editItemDialogVisible">
      <el-form
        ref="editFormRef"
        label-position="left"
        :model="editItemDialogData"
        label-width="200px"
        :rules="rules2"
      >
        <el-form-item
          label="合作单位"
          v-if="
            editItemDialogData.title != '项目管理费' &&
            editItemDialogData.title != '内部应转费用'
          "
        >
          <el-select
            :disabled="editItemDialogData.dataSource == 'MIDDLE'"
            v-model="editItemDialogData.partyBId"
            placeholder="请选择"
            @change="partyBEditChange"
          >
            <el-option
              v-for="(item, index) in partyBToSelect"
              :key="'partyB_' + index"
              :label="item.partyB"
              :value="item.partyBId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="合同内容"
          v-if="
            editItemDialogData.title != '项目管理费' &&
            editItemDialogData.title != '内部应转费用'
          "
        >
          <el-select
            :disabled="editItemDialogData.dataSource == 'MIDDLE'"
            v-model="editItemDialogData.contractContent"
            placeholder="请选择"
            @change="contractContentEditChange"
          >
            <el-option
              v-for="(item, index) in contentToSelect"
              :key="'content_' + index"
              :label="item.content"
              :value="item.content"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同编号">
          <el-input
            :value="editItemDialogData.serialNumber"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同金额（含税）">
          <el-input
            v-model="editItemDialogData.amount"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="税后合价" prop="settleAmount">
          <el-input-number
            v-model="editItemDialogData.settleAmount"
            controls-position="right"
            clearable
            :disabled="editItemDialogData.dataSource == 'MIDDLE'"
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="taxBillAmountEditChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="裸税合价" prop="cost">
          <el-input-number
            v-model="editItemDialogData.cost"
            controls-position="right"
            clearable
            :disabled="editItemDialogData.dataSource == 'MIDDLE'"
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="costEditChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="开具发票（含税金额）" prop="taxBillAmount">
          <el-input-number
            v-model="editItemDialogData.taxBillAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="taxBillAmountEditChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="开具发票（不含税金额）">
          <el-input-number
            v-model="editItemDialogData.noTaxBillAmount"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            :disabled="true"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="未开具发票（含税金额）">
          <el-input-number
            v-model="editItemDialogData.taxNoBillAmount"
            controls-position="right"
            clearable
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            :disabled="true"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="未开具发票（暂行税率）[%]" prop="taxRateCurrent">
          <el-input-number
            v-model="editItemDialogData.taxRateCurrent"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
            @change="taxRateCurrentEditChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="未开具发票（不含税金额）">
          <el-input-number
            v-model="editItemDialogData.noTaxNoBillAmount"
            controls-position="right"
            clearable
            :max="9999999999999"
            :precision="2"
            placeholder=""
            :disabled="true"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="累计已付款">
          <el-input-number
            v-model="editItemDialogData.alreadyPay"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="本次拟付款">
          <el-input-number
            v-model="editItemDialogData.thisPay"
            controls-position="right"
            clearable
            :min="0"
            :max="9999999999999"
            :precision="2"
            placeholder="请输入"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            v-model="editItemDialogData.remark"
            placeholder="请输入"
            clearable
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="info" @click.stop="cancelEditItem">取消</el-button>
        <el-button type="primary" @click.stop="confirmEditItem">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 收入成本管理-编辑收入记录
 * 第1个form只有项目部和项目名称可以选择，税率可以填写，其他的都是选定部门和项目之后带出来的
 */
import {
  getDeptList,
  getProjectList,
  getReceiptsEarningCost,
  getSubInfoByProjectId,
  editEarningCost,
  earningCost,
  querySubInfoByPartyBIdApi,
  createApproveProcessServiceApi,
} from "../../services/financeService";
import {
	updateApproveProcessStatusService,
} from "@/services/approveServices";
import Constants from "../../utils/consts";
import {
  formatMoney,
  formatPercent,
  getDefaultItem,
  getDefaultSum,
  isNil,
  isNotNil,
} from "./utils";
import approveLine from "@/page/approveComponents/NewApproveLine"; //审批流程

export default {
  components: {
    approveLine,
  },
  data() {
    return {
      type: "", //劳务、材料、机械、其它类型新增编辑区分
      approveType: "incomeManagement", //审批类型
      approveClass: "EARNING_COST",
      flag:false,  //是否保存过审批流
      approveList: [], //审批流
      // 直接成本，只需要展示数据即可
      directCostData: {
        // 劳务费
        laborVO: {
          // 实际不含税金额
          actNoTaxAmount: 0,
          // 实际含税金额
          actTaxAmount: 0,
          // 合同金额
          contractAmount: 0,
          // 预算不含税金额
          expectNoTaxAmount: 0,
          // 预算含税金额
          expectTaxAmount: 0,
        },
        // 机械使用费
        machineVO: {
          actNoTaxAmount: 0,
          actTaxAmount: 0,
          contractAmount: 0,
          expectNoTaxAmount: 0,
          expectTaxAmount: 0,
        },
        // 材料费
        materialVO: {
          actNoTaxAmount: 0,
          actTaxAmount: 0,
          contractAmount: 0,
          expectNoTaxAmount: 0,
          expectTaxAmount: 0,
        },
        // 其他直接费
        othersVO: {
          actNoTaxAmount: 0,
          actTaxAmount: 0,
          contractAmount: 0,
          expectNoTaxAmount: 0,
          expectTaxAmount: 0,
        },
        // 小计
        sumVO: {
          actNoTaxAmount: 0,
          actTaxAmount: 0,
          contractAmount: 0,
          expectNoTaxAmount: 0,
          expectTaxAmount: 0,
        },
      },
      activeName: "first",
      tableData: [],
      tableData2: [],
      id: undefined,
      basicData: {},
      deptListForSelect: [],
      projectListForSelect: [],
      formData: {
        deptId: undefined, // 项目部id
        projectId: undefined, // 项目id
        loanPct: undefined, //贷款利率
        expectIncomePct: undefined, //  预计可实现收入
      },
      rules1: {
        deptId: [
          { required: true, message: "请选择项目部", trigger: "change" },
        ],
        projectId: [
          { required: true, message: "请选择项目名称", trigger: "change" },
        ],
        loanPct: [
          { required: true, message: "请输入贷款利率", trigger: "change" },
        ],
      },
      rules2: {
        partyBId: [
          { required: true, message: "请选择合作单位", trigger: "change" },
        ],
        contractContent: [
          { required: true, message: "请选择合同内容", trigger: "change" },
        ],
        settleAmount: [
          { required: true, message: "请填写税后合价", trigger: "blur" },
          // {
          //   min: 1,
          //   max: 16,
          //   message: "请输入16位以内数字",
          //   trigger: "blur",
          // },
        ],
        cost: [{ required: true, message: "请填写裸税合价", trigger: "blur" }],
        taxBillAmount: [
          { required: true, message: "开具发票（含税金额）", trigger: "blur" },
        ],
        noTaxBillAmount: [
          {
            required: true,
            message: "开具发票（不含税金额）",
            trigger: "blur",
          },
        ],
        taxRateCurrent: [
          {
            required: true,
            message: "未开具发票（暂行税率）",
            trigger: "blur",
          },
        ],
      },
      receiptsEarningCost: undefined, // 选定项目部和项目之后拉出来的项目基本数据
      groupAmount: undefined, // 收集团拨款金额,这里是下面表的合计出来的值，是个展示。【本表的累计已付款的合计数】
      capitalCost: undefined, // 资金成本,也只是个展示，【（已收计量金额-收集团拨款金额）* 贷款利率】
      taxRate: undefined, // 用来计算各种自动出来的值。每个项目都不一样，切换项目之后要重新获取
      serviceCost: [getDefaultItem()], // 表1添加的劳务费列表
      serviceCostSum: getDefaultSum(), // 表1劳务费的合计
      materialCost: [getDefaultItem()],
      materialCostSum: getDefaultSum(),
      machineCost: [getDefaultItem()],
      machineCostSum: getDefaultSum(),
      otherDirectCost: [getDefaultItem()],
      otherDirectCostSum: getDefaultSum(),
      projectManagementCost: [getDefaultItem()], // 这个只有一个数据，但是模拟成数组就可以复用代码
      projectManagementCostSum: getDefaultSum(),
      needPartyBAndContent: false,
      equipDeptCost: getDefaultItem(), //设备物资部
      facilityDeptCost: getDefaultItem(), //设施场
      projectDeptCost: getDefaultItem(), // 工程处
      sum6: getDefaultSum(), // 6单独的sum
      sum1_4: getDefaultSum(),
      sum5_6: getDefaultSum(),
      sum1_6: getDefaultSum(),
      addItemDialogTarget: undefined,
      addItemDialogData: {},
      addItemDialogVisible: false,
      selfGetDefaultItem: getDefaultItem,
      selfGetDefaultSum: getDefaultSum,
      editItemDialogTarget: undefined,
      editItemDialogData: {},
      editItemDialogVisible: false,
      subInfoToUse: [],
      partyBToSelect: [], //合同乙方，合作单位选择
      contentToSelect: [], //合同内容选择
      projectAmount_budgetTaxAmount: 0, // 合同金额-预算金额	-含税金额
      projectAmount_budgetNoTaxAmount: 0, // 合同金额-预算金额	-不含税金额
      provisionalAmount_actTaxAmount: 0, // 暂定金(变更金额)	-实际发生-含税金额
      provisionalAmount_actNoTaxAmount: 0, // 实际发生的不含税金额
      provisionalAmount_budgetNoTaxAmount: 0,
      provisionalAmount_budgetTaxAmount: 0,
      listCheckAmount_actTaxAmount: 0, //清单复核金额-实际发生-含税金额
      listCheckAmount_actNoTaxAmount: 0, //清单复核金额-实际发生-不含税金额
      listCheckAmount_budgetNoTaxAmount: 0,
      listCheckAmount_budgetTaxAmount: 0,
      contractPriceIndexAmount_actTaxAmount: 0, //合同物价指数金额-实际发生金额	-含税金额
      contractPriceIndexAmount_actNoTaxAmount: 0, //合同物价指数金额-实际发生金额	-不含税金额
      auditAmount_budgetTaxAmount: 0, //审计金额-预算金额	-含税金额
      auditAmount_budgetNoTaxAmount: 0, //审计金额-预算金额	-不含税金额

      projectManagementAmount_budgetTaxAmount: 0,
      projectManagementAmount_budgetNoTaxAmount: 0,
      projectManagementAmount_actTaxAmount: 0,
      projectManagementAmount_actNoTaxAmount: 0,

      otherIndirectAmount_budgetTaxAmount: 0,
      otherIndirectAmount_budgetNoTaxAmount: 0,
      otherIndirectAmount_actTaxAmount: 0,
      otherIndirectAmount_actNoTaxAmount: 0,

      indirectCostSum_budgetTaxAmount: 0,
      indirectCostSum_budgetNoTaxAmount: 0,
      indirectCostSum_settleAmount: 0,
      indirectCostSum_actNoTaxAmount: 0,

      contractGrossProfit_budgetTaxAmount: 0,
      contractGrossProfit_budgetNoTaxAmount: 0,
      contractGrossProfit_actTaxAmount: 0,
      contractGrossProfit_actNoTaxAmount: 0,

      totalContractCost_actTaxAmount: 0,
      totalContractCost_actNoTaxAmount: 0,
      totalContractCost_budgetTaxAmount: 0,
      totalContractCost_budgetNoTaxAmount: 0,

      contractTotalIncomeAmount_budgetTaxAmount: 0,
      contractTotalIncomeAmount_budgetNoTaxAmount: 0,
      contractTotalIncomeAmount_actNoTaxAmount: 0, //合同总收入金额-实际发生金额-不含税金额
      contractTotalIncomeAmount_actTaxAmount: 0, //合同总收入金额-实际发生金额-含税金额

      contractGrossProfitRate_budgetTaxAmount: 0,
      contractGrossProfitRate_budgetNoTaxAmount: 0,
      contractGrossProfitRate_actTaxAmount: 0,
      contractGrossProfitRate_actNoTaxAmount: 0,
    };
  },
  methods: {
    contractContentAddChange(value) {
      let target = this.contentToSelect.find((item) => item.content == value);
      if (target) {
        this.addItemDialogData.subContractId = target.id;
        this.addItemDialogData.amount = target.amount;
        this.addItemDialogData.serialNumber = target.serialNumber;
        this.addItemDialogData.settleAmount = target.settleAmount;
        this.addItemDialogData.cost = target.cost;
      } else {
        this.addItemDialogData.subContractId = null;
        this.addItemDialogData.amount = null;
        this.addItemDialogData.serialNumber = null;
        this.addItemDialogData.settleAmount = null;
        this.addItemDialogData.cost = null;
      }
    },
    contractContentEditChange(value) {
      let target = this.contentToSelect.find((item) => item.content == value);
      if (target) {
        this.editItemDialogData.subContractId = target.id;
        this.editItemDialogData.amount = target.amount;
        this.editItemDialogData.serialNumber = target.serialNumber;
        this.editItemDialogData.settleAmount = target.settleAmount;
        this.editItemDialogData.cost = target.cost;
      } else {
        this.editItemDialogData.subContractId = null;
        this.editItemDialogData.amount = null;
        this.editItemDialogData.serialNumber = null;
        this.editItemDialogData.settleAmount = null;
        this.editItemDialogData.cost = null;
      }
    },
    //存储审批流
    saveApproveLine(selectItems,flag=false) {
      this.flag=flag
      this.approveList = selectItems;
    },
    spanArrayMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan,
        };
      }
    },
    spanArrayMethod2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 0) {
        return {
          rowspan: row.rowspan,
          colspan: 1,
        };
      }
      if (columnIndex == 1) {
        return {
          rowspan: row.rowspan,
          colspan: row.colspan,
        };
      }
      if (columnIndex == 2) {
        return {
          rowspan: row.rowspan2,
          colspan: row.colspan2,
        };
      }
    },
    formatTableData() {
      let res = [];

      let serviceCost = this.serviceCost;
      serviceCost.forEach((item, index) => {
        if (index == 0) {
          item.rowspan = serviceCost.length + 1; // 劳务费的小计也算在里面，所以要加个1
          item.colspan = 1;
        } else {
          item.rowspan = 0;
          item.colspan = 0;
        }
        let temp = Object.assign(item, {
          title: "劳务费",
          typeName: "劳务费",
          handler: true,
          multi: true,
          myindex: index + 1,
        });

        res.push(temp);
      });
      if (this.serviceCostSum) {
        let temp = Object.assign(this.serviceCostSum, {
          title: "",
          typeName: "劳务费",
          partyB: "小计",
          handler: false,
          hideTaxRateCurrent: true,
        });
        temp.rowspan = 0;
        temp.colspan = 0;
        res.push(temp);
      } else {
        let temp = Object.assign(
          {},
          {
            title: "",
            typeName: "劳务费",
            partyB: "小计",
            handler: false,
            hideTaxRateCurrent: true,
          }
        );
        temp.rowspan = 0;
        temp.colspan = 0;
        res.push(temp);
      }

      let materialCost = this.materialCost;
      materialCost.forEach((item, index) => {
        if (index == 0) {
          item.rowspan = materialCost.length + 1;
          item.colspan = 1;
        } else {
          item.rowspan = 0;
          item.colspan = 0;
        }
        let temp = Object.assign(item, {
          title: "材料费",
          typeName: "材料费",
          handler: true,
          multi: true,
          myindex: index + 1,
        });
        res.push(temp);
      });
      if (this.materialCostSum) {
        let temp = Object.assign(this.materialCostSum, {
          title: "",
          typeName: "材料费",
          partyB: "小计",
          handler: false,
          hideTaxRateCurrent: true,
        });
        temp.rowspan = 0;
        temp.colspan = 0;
        res.push(temp);
      } else {
        let temp = Object.assign(
          {},
          {
            title: "",
            typeName: "材料费",
            partyB: "小计",
            handler: false,
            hideTaxRateCurrent: true,
          }
        );
        temp.rowspan = 0;
        temp.colspan = 0;
        res.push(temp);
      }

      let machineCost = this.machineCost;
      machineCost.forEach((item, index) => {
        if (index == 0) {
          item.rowspan = machineCost.length + 1;
          item.colspan = 1;
        } else {
          item.rowspan = 0;
          item.colspan = 0;
        }
        let temp = Object.assign(item, {
          title: "机械费",
          typeName: "机械费",
          handler: true,
          multi: true,
          myindex: index + 1,
        });
        res.push(temp);
      });

      if (this.machineCostSum) {
        let temp = Object.assign(this.machineCostSum, {
          title: "",
          typeName: "机械费",
          partyB: "小计",
          handler: false,
          hideTaxRateCurrent: true,
        });
        temp.rowspan = 0;
        temp.colspan = 0;
        res.push(temp);
      } else {
        let temp = Object.assign(
          {},
          {
            title: "",
            typeName: "机械费",
            partyB: "小计",
            handler: false,
            hideTaxRateCurrent: true,
          }
        );
        temp.rowspan = 0;
        temp.colspan = 0;
        res.push(temp);
      }

      let otherDirectCost = this.otherDirectCost;
      otherDirectCost.forEach((item, index) => {
        if (index == 0) {
          item.rowspan = otherDirectCost.length + 1;
          item.colspan = 1;
        } else {
          item.rowspan = 0;
          item.colspan = 0;
        }
        let temp = Object.assign(item, {
          title: "其他直接费",
          typeName: "其他直接费",
          handler: true,
          multi: true,
          myindex: index + 1,
        });
        res.push(temp);
      });

      if (this.otherDirectCostSum) {
        let temp = Object.assign(this.otherDirectCostSum, {
          title: "",
          typeName: "其他直接费",
          partyB: "小计",
          handler: false,
          hideTaxRateCurrent: true,
        });
        temp.colspan = 0;
        temp.rowspan = 0;
        res.push(temp);
      } else {
        let temp = Object.assign(
          {},
          {
            title: "",
            typeName: "其他直接费",
            partyB: "小计",
            handler: false,
            hideTaxRateCurrent: true,
          }
        );
        temp.colspan = 0;
        temp.rowspan = 0;
        res.push(temp);
      }

      let temp = Object.assign(this.sum1_4, {
        title: "",
        typeName: "工料机合计",
        partyB: "工料机合计",
        handler: false,
        hideTaxRateCurrent: true,
      });
      temp.colspan = 1;
      temp.rowspan = 1;
      res.push(temp);

      let projectManagementCost = this.projectManagementCost;
      // 项目管理费其实就1条
      projectManagementCost.forEach((item, index) => {
        item.colspan = 1;
        item.rowspan = 2;
        let temp = Object.assign(item, {
          title: "项目管理费",
          typeName: "项目管理费",
          handler: true,
          multi: false,
          myindex: index + 1,
        });
        res.push(temp);
      });

      if (this.projectManagementCostSum) {
        let temp = Object.assign(this.projectManagementCostSum, {
          title: "",
          typeName: "项目管理费",
          partyB: "小计",
          handler: false,
          hideTaxRateCurrent: true,
        });
        temp.rowspan = 0;
        temp.colspan = 0;
        res.push(temp);
      } else {
        let temp = Object.assign(
          {},
          {
            title: "",
            typeName: "项目管理费",
            partyB: "小计",
            handler: false,
            hideTaxRateCurrent: true,
          }
        );
        temp.rowspan = 0;
        temp.colspan = 0;
        res.push(temp);
      }

      let equipDeptCost = Object.assign(this.equipDeptCost, {
        title: "内部应转费用",
        typeName: "内部应转费用",
        partyB: "设备物资部",
        handler: true,
        multi: false,
        myindex: 1,
      });
      equipDeptCost.rowspan = 4;
      equipDeptCost.colspan = 1;
      res.push(equipDeptCost);

      let facilityDeptCost = Object.assign(this.facilityDeptCost, {
        title: "内部应转费用",
        typeName: "内部应转费用",
        partyB: "设施场",
        handler: true,
        multi: false,
        myindex: 2,
      });
      facilityDeptCost.rowspan = 0;
      facilityDeptCost.colspan = 0;
      res.push(facilityDeptCost);

      let projectDeptCost = Object.assign(this.projectDeptCost, {
        title: "内部应转费用",
        typeName: "内部应转费用",
        partyB: "工程处",
        handler: true,
        multi: false,
        myindex: 3,
      });
      projectDeptCost.rowspan = 0;
      projectDeptCost.colspan = 0;
      res.push(projectDeptCost);

      let sum6 = Object.assign(this.sum6, {
        title: "",
        typeName: "内部应转费用",
        partyB: "小计",
        handler: false,
        multi: false,
        hideTaxRateCurrent: true,
      });
      sum6.rowspan = 0;
      sum6.colspan = 0;
      res.push(sum6);

      let sum5_6 = Object.assign(this.sum5_6, {
        title: "",
        typeName: "间接费合计",
        partyB: "间接费合计",
        handler: false,
        multi: false,
        hideTaxRateCurrent: true,
      });
      sum5_6.rowspan = 1;
      sum5_6.colspan = 1;
      res.push(sum5_6);

      let sum1_6 = Object.assign(this.sum1_6, {
        title: "",
        typeName: "合计",
        partyB: "合计",
        handler: false,
        multi: false,
        hideTaxRateCurrent: true,
      });
      sum1_6.rowspan = 1;
      sum1_6.colspan = 1;
      res.push(sum1_6);

      this.tableData = res;
    },
    formatTableData2() {
      let result = [];
      /**
       * budgetTaxAmount-预算含税
       * budgetNoTaxAmount-预算不含税
       * actTaxAmount-实际含税
       * actNoTaxAmount-实际不含税
       */
      // 合同金额
      let htje = {
        title1: "合同金额",
        title2: "合同金额",
        rowspan: 1,
        colspan: 2,
        rowspan2: 0,
        colspan2: 0,
        budgetTaxAmountShowNum: true,
        budgetNoTaxAmountShowNum: true,
        remark: "",
        myindex: 1,
      };
      if (this.receiptsEarningCost) {
        htje.budgetTaxAmount = this.receiptsEarningCost.contractPrice;
        htje.budgetNoTaxAmount =
          this.receiptsEarningCost.contractPrice &&
          this.receiptsEarningCost.taxRate >= 0
            ? this.receiptsEarningCost.contractPrice /
              (1 + this.receiptsEarningCost.taxRate / 100)
            : undefined;
      } else {
        htje.budgetTaxAmount = undefined;
        htje.budgetNoTaxAmount = undefined;
      }
      result.push(htje);

      // 暂定金（变更金额）
      let zdjbgje = {
        title1: "暂定金（变更金额）",
        title2: "暂定金（变更金额）",
        rowspan: 1,
        colspan: 2,
        rowspan2: 0,
        colspan2: 0,
        budgetTaxAmountShowNum: true,
        budgetNoTaxAmountShowNum: true,
        budgetTaxAmount: this.provisionalAmount_budgetTaxAmount,
        budgetNoTaxAmount: this.provisionalAmount_budgetNoTaxAmount,
        actTaxAmountInput: true,
        actTaxAmountName: "provisionalAmount_actTaxAmount",
        actTaxAmount: this.provisionalAmount_actTaxAmount,
        actNoTaxAmount: this.provisionalAmount_actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        remark: "",
        myindex: 2,
      };

      result.push(zdjbgje);

      // 清单复核金额
      let qdfhje = {
        title1: "清单复核金额",
        title2: "清单复核金额",
        rowspan: 1,
        colspan: 2,
        rowspan2: 0,
        colspan2: 0,
        budgetTaxAmountShowNum: true,
        budgetTaxAmount: this.listCheckAmount_budgetTaxAmount,
        budgetNoTaxAmount: this.listCheckAmount_budgetNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmountInput: true,
        actTaxAmountName: "listCheckAmount_actTaxAmount",
        actTaxAmount: this.listCheckAmount_actTaxAmount,
        actNoTaxAmount: this.listCheckAmount_actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        remark: "",
        myindex: 3,
      };

      result.push(qdfhje);

      // 合同物价指数金额
      let htwjzsje = {
        title1: "合同物价指数金额",
        title2: "合同物价指数金额",
        rowspan: 1,
        colspan: 2,
        rowspan2: 0,
        colspan2: 0,
        budgetTaxAmount: undefined,
        budgetNoTaxAmount: undefined,
        actTaxAmountInput: true,
        actTaxAmountName: "contractPriceIndexAmount_actTaxAmount",
        actTaxAmount: this.contractPriceIndexAmount_actTaxAmount,
        actNoTaxAmount: this.contractPriceIndexAmount_actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        remark: "",
        myindex: 4,
      };
      result.push(htwjzsje);

      // 审计金额
      let sjje = {
        title1: "审计金额",
        title2: "审计金额",
        rowspan: 1,
        colspan: 2,
        rowspan2: 0,
        colspan2: 0,
        budgetTaxAmount: this.auditAmount_budgetTaxAmount,
        budgetTaxAmountShowNum: true,
        budgetNoTaxAmount: this.auditAmount_budgetNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: undefined,
        actNoTaxAmount: undefined,
        remark: "",
        myindex: 5,
      };
      result.push(sjje);

      // 合同总收入金额
      let htzsrje = {
        title1: "合同总收入金额",
        title2: "合同总收入金额",
        rowspan: 1,
        colspan: 2,
        remark: "",
        rowspan2: 0,
        colspan2: 0,
        budgetTaxAmount: this.contractTotalIncomeAmount_budgetTaxAmount,
        budgetNoTaxAmount: this.contractTotalIncomeAmount_budgetNoTaxAmount,
        budgetTaxAmountShowNum: true,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: this.contractTotalIncomeAmount_actTaxAmount,
        actTaxAmountInput: true,
        actTaxAmountName: "contractTotalIncomeAmount_actTaxAmount",
        actNoTaxAmount: this.contractTotalIncomeAmount_actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        myindex: 6,
      };
      result.push(htzsrje);

      // 直接成本-劳务费
      let zjcb_serviceCost = {
        title1: "直接成本",
        title2: "劳务费",
        rowspan: 5,
        colspan: 1,
        rowspan2: 1,
        colspan2: 1,
        remark: "",
        budgetTaxAmountShowNum: true,
        budgetTaxAmount: this.directCostData.laborVO.expectTaxAmount,
        budgetNoTaxAmount: this.directCostData.laborVO.expectNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: this.directCostData.laborVO.actTaxAmount,
        actTaxAmountShowNum: true,
        actNoTaxAmount: this.directCostData.laborVO.actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        contractAmount: this.directCostData.laborVO.contractAmount,
        myindex: 7,
      };
      result.push(zjcb_serviceCost);
      // 直接成本-材料费
      let zjcb_materialCost = {
        title1: "直接成本",
        title2: "材料费",
        rowspan: 0,
        colspan: 1,
        rowspan2: 1,
        colspan2: 1,
        remark: "",
        budgetTaxAmountShowNum: true,
        budgetTaxAmount: this.directCostData.materialVO.expectTaxAmount,
        budgetNoTaxAmount: this.directCostData.materialVO.expectNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: this.directCostData.materialVO.actTaxAmount,
        actTaxAmountShowNum: true,
        actNoTaxAmount: this.directCostData.materialVO.actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        contractAmount: this.directCostData.materialVO.contractAmount,
        myindex: 7,
      };
      result.push(zjcb_materialCost);

      // 直接成本-机械使用费
      let zjcb_machineCost = {
        title1: "直接成本",
        title2: "机械使用费",
        rowspan: 0,
        colspan: 1,
        rowspan2: 1,
        colspan2: 1,
        remark: "",
        budgetTaxAmountShowNum: true,
        budgetTaxAmount: this.directCostData.machineVO.expectTaxAmount,
        budgetNoTaxAmount: this.directCostData.machineVO.expectNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: this.directCostData.machineVO.actTaxAmount,
        actTaxAmountShowNum: true,
        actNoTaxAmount: this.directCostData.machineVO.actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        contractAmount: this.directCostData.machineVO.contractAmount,
        myindex: 7,
      };
      result.push(zjcb_machineCost);

      // 直接成本-其他直接费
      let zjcb_otherDirectCost = {
        title1: "直接成本",
        title2: "其他直接费",
        rowspan: 0,
        colspan: 1,
        rowspan2: 1,
        colspan2: 1,
        remark: "",
        budgetTaxAmountShowNum: true,
        budgetTaxAmount: this.directCostData.othersVO.expectTaxAmount,
        budgetNoTaxAmount: this.directCostData.othersVO.expectNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: this.directCostData.othersVO.actTaxAmount,
        actTaxAmountShowNum: true,
        actNoTaxAmount: this.directCostData.othersVO.actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        contractAmount: this.directCostData.othersVO.contractAmount,
        myindex: 7,
      };
      result.push(zjcb_otherDirectCost);
      // 直接成本-小计
      let zjcb_sum = {
        title1: "直接成本",
        title2: "小计",
        rowspan: 0,
        colspan: 1,
        rowspan2: 1,
        colspan2: 1,
        remark: "",
        budgetTaxAmount: this.directCostData.sumVO.expectTaxAmount,
        budgetTaxAmountShowNum: true,
        budgetNoTaxAmount: this.directCostData.sumVO.expectNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: this.directCostData.sumVO.actTaxAmount,
        actTaxAmountShowNum: true,
        actNoTaxAmount: this.directCostData.sumVO.actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        contractAmount: this.directCostData.sumVO.contractAmount,
        myindex: 7,
      };
      result.push(zjcb_sum);

      // 间接成本-管理费用
      let jjcb_projectManagementCost = {
        title1: "间接成本",
        title2: "管理费用",
        rowspan: 3,
        colspan: 1,
        rowspan2: 1,
        colspan2: 1,
        remark: "",
        budgetTaxAmountInput: true,
        budgetTaxAmountName: "projectManagementAmount_budgetTaxAmount",
        budgetTaxAmount: this.projectManagementAmount_budgetTaxAmount,
        budgetNoTaxAmount: this.projectManagementAmount_budgetNoTaxAmount,
        budgetNoTaxAmountInput: true,
        budgetNoTaxAmountName: "projectManagementAmount_budgetNoTaxAmount",
        actTaxAmount: this.projectManagementAmount_actTaxAmount,
        actTaxAmountInput: true,
        actTaxAmountName: "projectManagementAmount_actTaxAmount",
        actNoTaxAmount: this.projectManagementAmount_actNoTaxAmount,
        actNoTaxAmountInput: true,
        actNoTaxAmountName: "projectManagementAmount_actNoTaxAmount",
        myindex: 8,
      };
      result.push(jjcb_projectManagementCost);

      // 间接成本-其他
      let jjcb_other = {
        title1: "间接成本",
        title2: "其他",
        rowspan: 0,
        colspan: 1,
        rowspan2: 1,
        colspan2: 1,
        remark: "",
        budgetTaxAmountInput: true,
        budgetTaxAmountName: "otherIndirectAmount_budgetTaxAmount",
        budgetTaxAmount: this.otherIndirectAmount_budgetTaxAmount,
        budgetNoTaxAmount: this.otherIndirectAmount_budgetNoTaxAmount,
        budgetNoTaxAmountInput: true,
        budgetNoTaxAmountName: "otherIndirectAmount_budgetNoTaxAmount",
        actTaxAmount: this.otherIndirectAmount_actTaxAmount,
        actTaxAmountInput: true,
        actTaxAmountName: "otherIndirectAmount_actTaxAmount",
        actNoTaxAmount: this.otherIndirectAmount_actNoTaxAmount,
        actNoTaxAmountInput: true,
        actNoTaxAmountName: "otherIndirectAmount_actNoTaxAmount",
        myindex: 8,
      };
      result.push(jjcb_other);

      // 间接成本-小计
      let jjcb_sum = {
        title1: "间接成本",
        title2: "小计",
        rowspan: 0,
        colspan: 1,
        rowspan2: 1,
        colspan2: 1,
        remark: "",
        budgetTaxAmount: this.indirectCostSum_budgetTaxAmount,
        budgetTaxAmountShowNum: true,
        budgetNoTaxAmount: this.indirectCostSum_budgetNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: this.indirectCostSum_settleAmount,
        actTaxAmountShowNum: true,
        actNoTaxAmount: this.indirectCostSum_actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        myindex: 8,
      };
      result.push(jjcb_sum);

      let htzcb_sum = {
        title1: "合同总成本合计",
        title2: "合同总成本合计",
        rowspan: 1,
        colspan: 2,
        rowspan2: 0,
        colspan2: 0,
        remark: "",
        budgetTaxAmount: this.totalContractCost_budgetTaxAmount,
        budgetTaxAmountShowNum: true,
        budgetNoTaxAmount: this.totalContractCost_budgetNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: this.totalContractCost_actTaxAmount,
        actTaxAmountShowNum: true,
        actNoTaxAmount: this.totalContractCost_actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        myindex: 9,
      };
      result.push(htzcb_sum);

      let html_sum = {
        title1: "合同毛利",
        title2: "合同毛利",
        rowspan: 1,
        colspan: 2,
        rowspan2: 0,
        colspan2: 0,
        remark: "",
        budgetTaxAmount: this.contractGrossProfit_budgetTaxAmount,
        budgetTaxAmountShowNum: true,
        budgetNoTaxAmount: this.contractGrossProfit_budgetNoTaxAmount,
        budgetNoTaxAmountShowNum: true,
        actTaxAmount: this.contractGrossProfit_actTaxAmount,
        actTaxAmountShowNum: true,
        actNoTaxAmount: this.contractGrossProfit_actNoTaxAmount,
        actNoTaxAmountShowNum: true,
        myindex: 10,
      };
      result.push(html_sum);

      let htmll_sum = {
        title1: "合同毛利率",
        title2: "合同毛利率",
        rowspan: 1,
        colspan: 2,
        rowspan2: 0,
        colspan2: 0,
        remark: "",
        budgetTaxAmount: this.contractGrossProfitRate_budgetTaxAmount,
        budgetTaxAmountShowPct: true,
        budgetNoTaxAmount: this.contractGrossProfitRate_budgetNoTaxAmount,
        budgetNoTaxAmountShowPct: true,
        actTaxAmount: this.contractGrossProfitRate_actTaxAmount,
        actTaxAmountShowPct: true,
        actNoTaxAmount: this.contractGrossProfitRate_actNoTaxAmount,
        actNoTaxAmountShowPct: true,
        myindex: 11,
      };
      result.push(htmll_sum);
      this.tableData2 = result;
      return result;
    },
    actTaxAmountChange(value, name) {
      if (name == "provisionalAmount_actTaxAmount") {
        // 暂定金-实际-含税金额变了
        this.provisionalAmount_actTaxAmount = value;
        this.provisionalAmount_actTaxAmount_changed(value);
      } else if (name == "listCheckAmount_actTaxAmount") {
        // 清单复核金额
        this.listCheckAmount_actTaxAmount = value;
        this.listCheckAmount_actTaxAmount_changed(value);
      } else if (name == "contractPriceIndexAmount_actTaxAmount") {
        // 合同物价指数金额
        this.contractPriceIndexAmount_actTaxAmount = value;
        this.contractPriceIndexAmount_actTaxAmount_changed(value);
      } else if (name == "contractTotalIncomeAmount_actTaxAmount") {
        // 合同总收入金额
        this.contractTotalIncomeAmount_actTaxAmount = value;
        this.contractTotalIncomeAmount_actTaxAmount_changed(value);
      } else if (name == "projectManagementAmount_actTaxAmount") {
        this.projectManagementAmount_actTaxAmount = value;
        this.indirectInputChange(value);
      } else if (name == "otherIndirectAmount_actTaxAmount") {
        // 间接成本管理费用-实际含税
        this.otherIndirectAmount_actTaxAmount = value;
        this.indirectInputChange(value);
      }
    },
    actNoTaxAmountChange(value, name) {
      switch (name) {
        case "projectManagementAmount_actNoTaxAmount":
          this.projectManagementAmount_actNoTaxAmount = value;
          this.indirectInputChange(value);
          break;
        case "otherIndirectAmount_actNoTaxAmount":
          this.otherIndirectAmount_actNoTaxAmount = value;
          this.indirectInputChange(value);
          break;
        default:
          break;
      }
    },
    budgetTaxAmountChange(value, name) {
      if (name == "projectManagementAmount_budgetTaxAmount") {
        this.projectManagementAmount_budgetTaxAmount = value;
        this.indirectInputChange(value);
      } else if (name == "otherIndirectAmount_budgetTaxAmount") {
        this.otherIndirectAmount_budgetTaxAmount = value;
        this.indirectInputChange(value);
      }
    },
    budgetNoTaxAmountChange(value, name) {
      switch (name) {
        case "projectManagementAmount_budgetNoTaxAmount":
          this.projectManagementAmount_budgetNoTaxAmount = value;
          this.indirectInputChange(value);
          break;
        case "otherIndirectAmount_budgetNoTaxAmount":
          this.otherIndirectAmount_budgetNoTaxAmount = value;
          this.indirectInputChange(value);
          break;
        default:
          break;
      }
    },
    closePage() {
      this.$refs["formRef1"].resetFields();
      this.bus.$emit("tabClose", "EditEarningItem");
      this.bus.$emit("navMenuChange", {
        routeId: "incomeConstList",
      });
    },
    formatMoneyNumber: formatMoney,
    formatPercentNumber: formatPercent,
    onActive() {
      let params = this.tabRouteParam || {};
      if (params.id) {
        this.id = params.id;
      }
      // 获取基本数据
      this.getDetailData();
      // 获取可选的项目部列表
      this.getDeptListForSelect();
    },
   
    getDetailData() {
      earningCost({
        id: this.id,
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            let resData = res.data || {};
            this.basicData = resData;

            const { deptId, projectId } = res.data;
            this.formData.deptId = deptId;
            this.formData.projectId = projectId;
            this.formData.loanPct = res.data.loanPct;
            this.formData.expectIncomePct = res.data.expectIncomePct;
            // 获取一次可选择的项目列表，为了展示出数据
            this.getProjectListForSelect();
            // 在编辑和新加时候用到
            this.getSubInfoByProjectIdToUse();
            this.receiptsEarningCost = {
              belongYear: res.data.belongYear, // 项目所属年度
              processStatusDisplayName: res.data.projectProcess, // 工程进度
              contractPrice: res.data.contractAmount, // 合同金额，form里用的
              finishPriceSum: res.data.finishPriceSum, // 已完成工作量
              calculatePriceSum: res.data.calculatePriceSum, // 上报计量
              receiptPriceSum: res.data.receiptPriceSum, // 已收计量金额
              taxRate: res.data.taxRate,
              auditAmount: res.data.auditAmount.budgetTaxAmount || 0, // 审核金额
              provisionalAmount: res.data.provisionalAmount,
            };
            // 表2的合同金额。合同金额只有预算金额，没有实际金额
            // 合同金额就是上面form里的合同金额，但上面的form不能修改，所以这里合同金额是不能改的。
            if (res.data.projectAmount) {
              this.projectAmount_budgetTaxAmount =
                res.data.projectAmount.budgetTaxAmount;
              this.projectAmount_budgetNoTaxAmount =
                res.data.projectAmount.budgetNoTaxAmount;
            }

            this.groupAmount = res.data.groupAmount; //收集团拨款金额
            this.capitalCost = res.data.capitalCost; //资金成本

            // 表格1
            this.serviceCost =
              res.data.serviceCostAnalysis && res.data.serviceCostAnalysis.length
                ? res.data.serviceCostAnalysis
                : [getDefaultItem()]; //劳务费
            this.serviceCostSum = res.data.serviceCostTotal || getDefaultSum();
            this.materialCost =
              res.data.materialCostAnalysis && res.data.materialCostAnalysis.length
                ? res.data.materialCostAnalysis
                : [getDefaultItem()];
            this.materialCostSum =
              res.data.materialCostTotal || getDefaultSum();
            this.machineCost =
              res.data.machineCostAnalysis && res.data.machineCostAnalysis.length
                ? res.data.machineCostAnalysis
                : [getDefaultItem()];
            this.machineCostSum = res.data.machineCostTotal || getDefaultSum();
            this.otherDirectCost =
              res.data.otherDirectCostAnalysis && res.data.otherDirectCostAnalysis.length
                ? res.data.otherDirectCostAnalysis
                : [getDefaultItem()];
            this.otherDirectCostSum =
              res.data.otherDirectCostTotal || getDefaultSum();
            this.sum1_4 = res.data.oneToFourTotal || getDefaultSum();
            this.projectManagementCost = res.data.projectManagementCost
              ? [res.data.projectManagementCost]
              : [getDefaultItem()];
            let projectManagementCostSum = getDefaultSum();
            if (res.data.projectManagementCost) {
              let keys = Object.keys(projectManagementCostSum);
              for (let i = 0; i < keys.length; i++) {
                let val = res.data.projectManagementCost[keys[i]];
                projectManagementCostSum[keys[i]] = val;
              }
            }
            this.projectManagementCostSum = projectManagementCostSum;
            this.equipDeptCost = res.data.equipDeptCost || getDefaultItem(); //设备物资部
            this.facilityDeptCost =
              res.data.facilityDeptCost || getDefaultItem(); //设施场
            this.projectDeptCost = res.data.projectDeptCost || getDefaultItem(); //工程处
            this.sum6 = res.data.sixTotal || getDefaultSum(); // 6单独的sum
            this.sum5_6 = res.data.fiveAndSixTotal || getDefaultSum();
            this.sum1_6 = res.data.allTotal || getDefaultSum();

            // 表格2
            if (resData.serviceAmount) {
              const {
                budgetNoTaxAmount,
                budgetTaxAmount,
                actTaxAmount,
                actNoTaxAmount,
                contractAmount,
              } = resData.serviceAmount;
              this.directCostData.laborVO.expectTaxAmount =
                budgetTaxAmount || 0;
              this.directCostData.laborVO.expectNoTaxAmount =
                budgetNoTaxAmount || 0;
              this.directCostData.laborVO.actTaxAmount = actTaxAmount || 0;
              this.directCostData.laborVO.actNoTaxAmount = actNoTaxAmount || 0;
              this.directCostData.laborVO.contractAmount = contractAmount || 0;
            }
            if (resData.materialAmount) {
              const {
                budgetNoTaxAmount = 0,
                budgetTaxAmount = 0,
                actTaxAmount = 0,
                actNoTaxAmount = 0,
                contractAmount = 0,
              } = resData.materialAmount;
              this.directCostData.materialVO.expectTaxAmount = budgetTaxAmount;
              this.directCostData.materialVO.expectNoTaxAmount =
                budgetNoTaxAmount;
              this.directCostData.materialVO.actTaxAmount = actTaxAmount;
              this.directCostData.materialVO.actNoTaxAmount = actNoTaxAmount;
              this.directCostData.materialVO.contractAmount = contractAmount;
            }
            if (resData.machineAmount) {
              const {
                budgetNoTaxAmount = 0,
                budgetTaxAmount = 0,
                actTaxAmount = 0,
                actNoTaxAmount = 0,
                contractAmount = 0,
              } = resData.machineAmount;
              this.directCostData.machineVO.expectTaxAmount = budgetTaxAmount;
              this.directCostData.machineVO.expectNoTaxAmount =
                budgetNoTaxAmount;
              this.directCostData.machineVO.actTaxAmount = actTaxAmount;
              this.directCostData.machineVO.actNoTaxAmount = actNoTaxAmount;
              this.directCostData.machineVO.contractAmount = contractAmount;
            }

            if (resData.otherDirectAmount) {
              const {
                budgetNoTaxAmount = 0,
                budgetTaxAmount = 0,
                actTaxAmount = 0,
                actNoTaxAmount = 0,
                contractAmount = 0,
              } = resData.otherDirectAmount;
              this.directCostData.othersVO.expectTaxAmount = budgetTaxAmount;
              this.directCostData.othersVO.expectNoTaxAmount =
                budgetNoTaxAmount;
              this.directCostData.othersVO.actTaxAmount = actTaxAmount;
              this.directCostData.othersVO.actNoTaxAmount = actNoTaxAmount;
              this.directCostData.othersVO.contractAmount = contractAmount;
            }

            if (resData.tableTwoDirectTotal) {
              const {
                budgetNoTaxAmount = 0,
                budgetTaxAmount = 0,
                actTaxAmount = 0,
                actNoTaxAmount = 0,
                contractAmount = 0,
              } = resData.tableTwoDirectTotal;
              this.directCostData.sumVO.expectTaxAmount = budgetTaxAmount;
              this.directCostData.sumVO.expectNoTaxAmount = budgetNoTaxAmount;
              this.directCostData.sumVO.actTaxAmount = actTaxAmount;
              this.directCostData.sumVO.actNoTaxAmount = actNoTaxAmount;
              this.directCostData.sumVO.contractAmount = contractAmount;
            }

            if (res.data.projectManagementAmount) {
              this.projectManagementAmount_budgetNoTaxAmount =
                res.data.projectManagementAmount.budgetNoTaxAmount;
              this.projectManagementAmount_budgetTaxAmount =
                res.data.projectManagementAmount.budgetTaxAmount;
              this.projectManagementAmount_actTaxAmount =
                res.data.projectManagementAmount.actTaxAmount;
              this.projectManagementAmount_actNoTaxAmount =
                res.data.projectManagementAmount.actNoTaxAmount;
            }

            if (res.data.otherIndirectAmount) {
              this.otherIndirectAmount_budgetNoTaxAmount =
                res.data.otherIndirectAmount.budgetNoTaxAmount;
              this.otherIndirectAmount_budgetTaxAmount =
                res.data.otherIndirectAmount.budgetTaxAmount;
              this.otherIndirectAmount_actTaxAmount =
                res.data.otherIndirectAmount.actTaxAmount;
              this.otherIndirectAmount_actNoTaxAmount =
                res.data.otherIndirectAmount.actNoTaxAmount;
            }

            if (res.data.tableTwoInDirectTotal) {
              this.indirectCostSum_budgetTaxAmount =
                res.data.tableTwoInDirectTotal.budgetTaxAmount;
              this.indirectCostSum_budgetNoTaxAmount =
                res.data.tableTwoInDirectTotal.budgetNoTaxAmount;
              this.indirectCostSum_settleAmount =
                res.data.tableTwoInDirectTotal.actTaxAmount;
              this.indirectCostSum_actNoTaxAmount =
                res.data.tableTwoInDirectTotal.actNoTaxAmount;
            }

            if (res.data.tableTwoAllCostTotal) {
              this.totalContractCost_actTaxAmount =
                res.data.tableTwoAllCostTotal.actTaxAmount;
              this.totalContractCost_actNoTaxAmount =
                res.data.tableTwoAllCostTotal.actNoTaxAmount;
              this.totalContractCost_budgetTaxAmount =
                res.data.tableTwoAllCostTotal.budgetTaxAmount;
              this.totalContractCost_budgetNoTaxAmount =
                res.data.tableTwoAllCostTotal.budgetNoTaxAmount;
            }

            if (res.data.tableTwoGrossProfit) {
              this.contractGrossProfit_actTaxAmount =
                res.data.tableTwoGrossProfit.actTaxAmount;
              this.contractGrossProfit_actNoTaxAmount =
                res.data.tableTwoGrossProfit.actNoTaxAmount;
              this.contractGrossProfit_budgetTaxAmount =
                res.data.tableTwoGrossProfit.budgetTaxAmount;
              this.contractGrossProfit_budgetNoTaxAmount =
                res.data.tableTwoGrossProfit.budgetNoTaxAmount;
            }

            if (res.data.tableTwoGrossMarginList) {
              this.contractGrossProfitRate_budgetTaxAmount =
                res.data.tableTwoGrossMarginList[0];
              this.contractGrossProfitRate_budgetNoTaxAmount =
                res.data.tableTwoGrossMarginList[1];
              this.contractGrossProfitRate_actTaxAmount =
                res.data.tableTwoGrossMarginList[2];
              this.contractGrossProfitRate_actNoTaxAmount =
                res.data.tableTwoGrossMarginList[3];
            }

            // 暂定金(变更金额)
            if (res.data.provisionalAmount) {
              // console.log('暂定金(变更金额)', res.data.provisionalAmount);
              this.provisionalAmount_budgetNoTaxAmount =
                res.data.provisionalAmount.budgetNoTaxAmount;
              this.provisionalAmount_budgetTaxAmount =
                res.data.provisionalAmount.budgetTaxAmount;
              this.provisionalAmount_actTaxAmount =
                res.data.provisionalAmount.actTaxAmount;
              this.provisionalAmount_actNoTaxAmount =
                res.data.provisionalAmount.actNoTaxAmount;
            }
            // 表格2-清单复核金额
            if (res.data.listCheckAmount) {
              this.listCheckAmount_budgetTaxAmount =
                res.data.listCheckAmount.budgetTaxAmount;
              this.listCheckAmount_budgetNoTaxAmount =
                res.data.listCheckAmount.budgetNoTaxAmount;
              this.listCheckAmount_actTaxAmount =
                res.data.listCheckAmount.actTaxAmount;
              this.listCheckAmount_actNoTaxAmount =
                res.data.listCheckAmount.actNoTaxAmount;
            }
            // 表格2-合同物价指数金额
            if (res.data.contractPriceIndexAmount) {
              this.contractPriceIndexAmount_actTaxAmount =
                res.data.contractPriceIndexAmount.actTaxAmount;
              this.contractPriceIndexAmount_actNoTaxAmount =
                res.data.contractPriceIndexAmount.actNoTaxAmount;
            }

            if (res.data.auditAmount) {
              this.auditAmount_budgetTaxAmount =
                res.data.auditAmount.budgetTaxAmount;
              this.auditAmount_budgetNoTaxAmount =
                res.data.auditAmount.budgetNoTaxAmount;
            }

            // 合同总收入金额
            if (res.data.contractTotalIncomeAmount) {
              this.contractTotalIncomeAmount_budgetTaxAmount =
                res.data.contractTotalIncomeAmount.budgetTaxAmount;
              this.contractTotalIncomeAmount_budgetNoTaxAmount =
                res.data.contractTotalIncomeAmount.budgetNoTaxAmount;
              this.contractTotalIncomeAmount_actNoTaxAmount =
                res.data.contractTotalIncomeAmount.actNoTaxAmount;
              this.contractTotalIncomeAmount_actTaxAmount =
                res.data.contractTotalIncomeAmount.actTaxAmount;
            }

            this.formatTableData();
            this.formatTableData2();
          } else {
            this.basicData = {};
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    /**
     * 获取项目部列表
     */
    getDeptListForSelect() {
      getDeptList()
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.deptListForSelect = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /**
     * 获取选定的项目部下面的项目列表
     */
    getProjectListForSelect() {
      getProjectList({ deptId: this.formData.deptId })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            // 返回的数据{ id, name }
            this.projectListForSelect = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /**
     * 切换项目部之后，重置一些数据
     */
    resetFormDataAfterDept() {
      this.formData.projectId = undefined; // 项目部都改了，项目肯定就改了
      this.projectListForSelect = [];
      this.resetAllData();
    },
    /**
     * 切换项目之后，重置数据
     */
    resetFormDataAfterProject() {
      // this.taxRate = 0;
      this.resetAllData(); // 选定项目部和项目之后才有具体的内容，所以改了项目部或者项目，都要重置。
    },

    /**
     * 重置下全部的数据
     */
    resetAllData() {
      this.receiptsEarningCost = {
        belongYear: undefined, // 项目所属年度
        processStatusDisplayName: undefined, // 工程进度
        contractPrice: undefined, // 合同金额
        finishPriceSum: undefined, // 已完成工作量
        calculatePriceSum: undefined, // 上报计量
        receiptPriceSum: undefined, // 已收计量金额
        taxRate: 0,
        provisionalAmount: undefined,
      };

      this.groupAmount = undefined; //收集团拨款金额
      this.capitalCost = undefined; //资金成本
      this.formData.loanPct = undefined; //贷款利率

      // 表格1
      this.serviceCost = [getDefaultItem()]; //劳务费
      this.serviceCostSum = getDefaultSum();
      this.materialCost = [getDefaultItem()];
      this.materialCostSum = getDefaultSum();
      this.machineCost = [getDefaultItem()];
      this.machineCostSum = getDefaultSum();
      this.otherDirectCost = [getDefaultItem()];
      this.otherDirectCostSum = getDefaultSum();
      this.sum1_4 = getDefaultSum();
      this.projectManagementCost = [getDefaultItem()];
      this.projectManagementCostSum = getDefaultSum();
      this.equipDeptCost = getDefaultItem(); //设备物资部
      this.facilityDeptCost = getDefaultItem(); //设施场
      this.projectDeptCost = getDefaultItem(); //工程处
      this.sum6 = getDefaultSum(); // 6单独的sum
      this.sum5_6 = getDefaultSum();
      this.sum1_6 = getDefaultSum();

      // 表格2

      this.projectManagementAmount_budgetNoTaxAmount = undefined;
      this.projectManagementAmount_budgetTaxAmount = undefined;
      this.projectManagementAmount_actTaxAmount = undefined;
      this.projectManagementAmount_actNoTaxAmount = undefined;

      this.otherIndirectAmount_budgetNoTaxAmount = undefined;
      this.otherIndirectAmount_budgetTaxAmount = undefined;
      this.otherIndirectAmount_actTaxAmount = undefined;
      this.otherIndirectAmount_actNoTaxAmount = undefined;

      this.tableTwoInDirectTotal_budgetNoTaxAmount = undefined;
      this.tableTwoInDirectTotal_budgetTaxAmount = undefined;

      this.totalContractCost_actTaxAmount = undefined;
      this.totalContractCost_actNoTaxAmount = undefined;
      this.totalContractCost_budgetTaxAmount = undefined;
      this.totalContractCost_budgetNoTaxAmount = undefined;

      this.contractGrossProfit_actTaxAmount = undefined;
      this.contractGrossProfit_actNoTaxAmount = undefined;
      this.contractGrossProfit_budgetTaxAmount = undefined;
      this.contractGrossProfit_budgetNoTaxAmount = undefined;

      this.contractGrossProfitRate_budgetTaxAmount = undefined;
      this.contractGrossProfitRate_budgetNoTaxAmount = undefined;
      this.contractGrossProfitRate_actTaxAmount = undefined;
      this.contractGrossProfitRate_actNoTaxAmount = undefined;

      this.provisionalAmount_actTaxAmount = undefined;
      this.provisionalAmount_actNoTaxAmount = undefined;
      this.provisionalAmount_budgetNoTaxAmount = undefined;
      this.provisionalAmount_budgetTaxAmount = undefined;

      this.listCheckAmount_actTaxAmount = undefined;
      this.listCheckAmount_actNoTaxAmount = undefined;
      this.listCheckAmount_budgetTaxAmount = undefined;

      this.contractPriceIndexAmount_actTaxAmount = undefined;
      this.contractPriceIndexAmount_actNoTaxAmount = undefined;

      this.auditAmount_budgetTaxAmount = undefined;
      this.auditAmount_budgetNoTaxAmount = undefined;

      this.contractTotalIncomeAmount_budgetTaxAmount = undefined;
      this.contractTotalIncomeAmount_budgetNoTaxAmount = undefined;
      this.contractTotalIncomeAmount_actNoTaxAmount = undefined;
      this.contractTotalIncomeAmount_actTaxAmount = undefined;

      this.indirectCostSum_budgetTaxAmount = undefined;
      this.indirectCostSum_budgetNoTaxAmount = undefined;
      this.indirectCostSum_settleAmount = undefined;
      this.indirectCostSum_actNoTaxAmount = undefined;

      this.formatTableData();
      this.formatTableData2();
    },

    /**
     * 选定项目之后，获取项目对应的一些数据显示出来
     * 查询收入成本详情
     */
    getDataAfterProject() {
      getReceiptsEarningCost({
        projectId: this.formData.projectId,
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.receiptsEarningCost = res.data || {};
            this.updateContractTotalIncomeAmount12();
            this.formatTableData2();
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /**
     * 贷款利率,失去焦点后计算一些值
     */
    loanPctBlur(value) {
      if (
        this.receiptsEarningCost &&
        this.receiptsEarningCost.receiptPriceSum &&
        this.groupAmount &&
        this.formData.loanPct
      ) {
        this.capitalCost = Number(
          (
            ((this.receiptsEarningCost.receiptPriceSum - this.groupAmount) *
              this.formData.loanPct) /
            100
          ).toFixed(2)
        );
      } else {
        this.capitalCost = 0.0;
      }
    },
    /**
     * 添加新的劳务费item
     */
    addItem(target, needPartyBAndContent) {
      if (target.typeName == "劳务费") {
        this.type = "LABOR";
        this.addItemDialogTarget = this.serviceCost;
      } else if (target.typeName == "材料费") {
        this.type = "MATERIAL";
        this.addItemDialogTarget = this.materialCost;
      } else if (target.typeName == "机械费") {
        this.type = "MACHINE";
        this.addItemDialogTarget = this.machineCost;
      } else if (target.typeName == "其他直接费") {
        this.type = "OTHERS";
        this.addItemDialogTarget = this.otherDirectCost;
      } else {
        this.type = "";
        throw new Error("--其他的都只有编辑，没有新增");
        return;
      }
      this.addItemDialogData = this.selfGetDefaultItem();
      this.needPartyBAndContent = needPartyBAndContent;
      this.addItemDialogVisible = true;
      this.$nextTick(() => {
        this.$refs["addFormRef"].clearValidate();
      });
    },
    costAddChange(value) {
      value = value || 0;
      this.addItemDialogData.taxNoBillAmount =
        (this.addItemDialogData.cost || 0) -
        (this.addItemDialogData.taxBillAmount || 0);
    },
    // 开具发票含税金额变了，要重新算未开具发票含税金额和未开具发票不含税金额
    taxBillAmountAddChange(value) {
      this.addItemDialogData.taxNoBillAmount =
        (this.addItemDialogData.settleAmount || 0) -
        (this.addItemDialogData.taxBillAmount || 0);

      this.addItemDialogData.taxRateCurrent =
        this.addItemDialogData.taxRateCurrent || 0;
      //开具发票（不含税金额）=开具发票（含税金额）/（1+暂行税率）20240117
      this.addItemDialogData.noTaxBillAmount = Number(
        (
          this.addItemDialogData.taxBillAmount /
          (1 + this.addItemDialogData.taxRateCurrent / 100)
        ).toFixed(2)
      );
      this.addItemDialogData.noTaxNoBillAmount = Number(
        (
          this.addItemDialogData.taxNoBillAmount /
          (1 + this.addItemDialogData.taxRateCurrent / 100)
        ).toFixed(2)
      );
    },
    // 未开具发票暂行税率变了，要重新计算未开具发票不含税金额\开具发票不含税金额
    taxRateCurrentAddChange(value) {
      this.addItemDialogData.taxRateCurrent =
        this.addItemDialogData.taxRateCurrent || 0;
      //开具发票（不含税金额）=开具发票（含税金额）/（1+暂行税率）20240117
      this.addItemDialogData.noTaxBillAmount = Number(
        (
          this.addItemDialogData.taxBillAmount /
          (1 + this.addItemDialogData.taxRateCurrent / 100)
        ).toFixed(2)
      );
      this.addItemDialogData.noTaxNoBillAmount = Number(
        (
          (this.addItemDialogData.taxNoBillAmount || 0) /
          (1 + this.addItemDialogData.taxRateCurrent / 100)
        ).toFixed(2)
      );
    },
    confirmAddItem() {
      this.$refs["addFormRef"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let addData = this.addItemDialogData;
        let partyBId = addData.partyBId;
        if (partyBId && this.partyBToSelect) {
          let target = this.partyBToSelect.find(
            (item) => item.partyBId == partyBId
          );
          if (target) {
            addData.partyB = target.partyB;
          }
        }
        if (
          isNotNil(addData.taxNoBillAmount) &&
          isNotNil(addData.taxRateCurrent)
        ) {
          addData.noTaxNoBillAmount = Number(
            (
              addData.taxNoBillAmount /
              (1 + addData.taxRateCurrent / 100)
            ).toFixed(2)
          ); //未开具发票（不含税金额）
        } else {
          addData.noTaxNoBillAmount = 0;
        }
        // 计算尚欠款=税后合价-累计已付款
        if (isNotNil(addData.settleAmount) && isNotNil(addData.alreadyPay)) {
          addData.debtAmount = Number(
            (addData.settleAmount - addData.alreadyPay).toFixed(2)
          );
        } else {
          addData.debtAmount = 0;
        }
        // 已付款比例=累计已付款/税后合价
        if (isNotNil(addData.settleAmount) && isNotNil(addData.alreadyPay)) {
          addData.alreadyPayPct = Number(
            ((addData.alreadyPay / addData.settleAmount) * 100).toFixed(2)
          );
        } else {
          addData.alreadyPayPct = 0;
        }
        //再付款比例=（本次拟付款+累计已付款）/税后合价
        if (
          isNotNil(addData.thisPay) &&
          isNotNil(addData.alreadyPay) &&
          isNotNil(addData.settleAmount)
        ) {
          addData.thisPayPct = Number(
            (
              ((addData.thisPay + addData.alreadyPay) / addData.settleAmount) *
              100
            ).toFixed(2)
          );
        } else {
          addData.thisPayPct = 0;
        }
        this.addItemDialogTarget.push(this.addItemDialogData);
        this.addItemDialogVisible = false;
        this.updateSum();
        this.updateIndirectCostSum34();
        this.updateTotalContractCost();
        this.updateContractGrossProfit();
        this.updateContractGrossProfitRate();
        this.formatTableData();
        this.formatTableData2();
      });
    },
    cancelAddItem() {
      this.$refs["addFormRef"].resetFields();
      this.addItemDialogVisible = false;
    },
    /**
     * 编辑劳务费item
     */
    editItem(item, needPartyBAndContent) {
      this.needPartyBAndContent = needPartyBAndContent;
      this.editItemDialogTarget = item;
      this.editItemDialogData = { ...item };
      this.editItemDialogVisible = true;
      this.$nextTick(() => {
        this.$refs["editFormRef"].clearValidate();
      });
    },
    costEditChange(value) {
      value = value || 0;
      // this.editItemDialogData.taxNoBillAmount =
      //   this.editItemDialogData.cost - this.editItemDialogData.taxBillAmount;
    },
    taxBillAmountEditChange(value) {
      // 2022-09-22 01:51:27 换公式了？
      this.editItemDialogData.taxNoBillAmount =
        (this.editItemDialogData.settleAmount || 0) -
        (this.editItemDialogData.taxBillAmount || 0);

      this.editItemDialogData.taxRateCurrent =
        this.editItemDialogData.taxRateCurrent || 0;
      this.editItemDialogData.noTaxBillAmount = Number(
        (
          (this.editItemDialogData.taxBillAmount || 0) /
          (1 + this.editItemDialogData.taxRateCurrent / 100)
        ).toFixed(2)
      );
      this.editItemDialogData.noTaxNoBillAmount = Number(
        (
          this.editItemDialogData.taxNoBillAmount /
          (1 + this.editItemDialogData.taxRateCurrent / 100)
        ).toFixed(2)
      );
    },
    // 未开具发票暂行税率变了，要重新计算未开具发票不含税金额
    taxRateCurrentEditChange(value) {
      this.editItemDialogData.taxRateCurrent =
        this.editItemDialogData.taxRateCurrent || 0;
      this.editItemDialogData.noTaxBillAmount = Number(
        (
          (this.editItemDialogData.taxBillAmount || 0) /
          (1 + this.editItemDialogData.taxRateCurrent / 100)
        ).toFixed(2)
      );
      this.editItemDialogData.noTaxNoBillAmount = Number(
        (
          (this.editItemDialogData.taxNoBillAmount || 0) /
          (1 + this.editItemDialogData.taxRateCurrent / 100)
        ).toFixed(2)
      );
    },
    confirmEditItem() {
      let editData = this.editItemDialogData;
      this.$refs["editFormRef"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let partyBId = editData.partyBId;
        if (partyBId && this.partyBToSelect) {
          let target = this.partyBToSelect.find(
            (item) => item.partyBId == partyBId
          );
          if (target) {
            editData.partyB = target.partyB;
          }
        }

        if (
          isNotNil(editData.taxNoBillAmount) &&
          isNotNil(editData.taxRateCurrent)
        ) {
          editData.noTaxNoBillAmount = Number(
            (
              editData.taxNoBillAmount /
              (1 + editData.taxRateCurrent / 100)
            ).toFixed(2)
          ); //未开具发票（不含税金额）
        } else {
          editData.noTaxNoBillAmount = 0;
        }
        // 计算尚欠款=税后合价-累计已付款
        if (isNotNil(editData.settleAmount) && isNotNil(editData.alreadyPay)) {
          editData.debtAmount = Number(
            (editData.settleAmount - editData.alreadyPay).toFixed(2)
          );
        } else {
          editData.debtAmount = 0;
        }
        // 已付款比例=累计已付款/税后合价
        if (isNotNil(editData.settleAmount) && isNotNil(editData.alreadyPay)) {
          editData.alreadyPayPct = Number(
            ((editData.alreadyPay / editData.settleAmount) * 100).toFixed(2)
          );
        } else {
          editData.alreadyPayPct = 0;
        }
        //再付款比例=（本次拟付款+累计已付款）/税后合价
        if (
          isNotNil(editData.thisPay) &&
          isNotNil(editData.alreadyPay) &&
          isNotNil(editData.settleAmount)
        ) {
          editData.thisPayPct = Number(
            (
              ((editData.thisPay + editData.alreadyPay) /
                editData.settleAmount) *
              100
            ).toFixed(2)
          );
        } else {
          editData.thisPayPct = 0;
        }
        let tt = this.editItemDialogTarget;
        let keys = Object.keys(editData);
        for (let i = 0; i < keys.length; i++) {
          let key = keys[i];
          this.$set(tt, key, editData[key]);
        }
        this.editItemDialogVisible = false;
        this.updateSum();
        this.updateIndirectCostSum34();
        this.updateTotalContractCost();
        this.updateContractGrossProfit();
        this.updateContractGrossProfitRate();
        this.formatTableData();
        this.formatTableData2();
      });
    },
    cancelEditItem() {
      this.$refs["editFormRef"].resetFields();
      this.editItemDialogVisible = false;
    },
    /**
     * 删除劳务费item
     */
    deleteItem(item) {
      let target;
      if (item.typeName == "劳务费") {
        target = this.serviceCost;
      } else if (item.typeName == "材料费") {
        target = this.materialCost;
      } else if (item.typeName == "机械费") {
        target = this.machineCost;
      } else if (item.typeName == "其他直接费") {
        target = this.otherDirectCost;
      } else {
        // console.log("--其他的都只有编辑，没有删除");
        return;
      }
      if (item && target) {
        let index = target.indexOf(item);
        if (index != -1) {
          target.splice(index, 1);
          if (target.length == 0) {
            target.push(getDefaultItem());
          }
          this.updateSum();
          this.updateIndirectCostSum34();
          this.updateTotalContractCost();
          this.updateContractGrossProfit();
          this.updateContractGrossProfitRate();
          this.formatTableData();
          this.formatTableData2();
        }
      }
    },

    /**
     * 选定项目之后，获取在添加和编辑时用到的合作单位和合同内容
     */
    getSubInfoByProjectIdToUse() {
      getSubInfoByProjectId({ projectId: this.formData.projectId })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.subInfoToUse = res.data || [];
            let list = [];
            for (let i = 0; i < this.subInfoToUse.length; i++) {
              let index = list.findIndex(
                (item) => item.partyB == this.subInfoToUse[i].partyB
              );
              if (index == -1) {
                list.push(this.subInfoToUse[i]);
              }
            }
            this.partyBToSelect = list;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    partyBAddChange() {
      let partyBId = this.addItemDialogData.partyBId;
      this.addItemDialogData.contractContent = null;
      this.addItemDialogData.subContractId = null;
      this.addItemDialogData.amount = null;
      this.addItemDialogData.serialNumber = null;
      this.addItemDialogData.settleAmount = null;
      this.addItemDialogData.cost = null;
      querySubInfoByPartyBIdApi({
        partyBId: partyBId,
        projectId: this.formData.projectId,
      })
        .then((res) => {
          // this.contentToSelect = res.data || [];
          let arr = res.data.filter((item) => item.type == this.type &&  this.serviceCost.every( (em) => em.serialNumber != item.serialNumber      )        )
          this.contentToSelect = arr||[];
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    partyBEditChange() {
      let partyBId = this.editItemDialogData.partyBId;
      this.editItemDialogData.contractContent = null;
      this.editItemDialogData.subContractId = null;
      this.editItemDialogData.amount = null;
      this.editItemDialogData.serialNumber = null;
      this.editItemDialogData.settleAmount = null;
      this.editItemDialogData.cost = null;
      querySubInfoByPartyBIdApi({
        partyBId: partyBId,
        projectId: this.formData.projectId,
      })
        .then((res) => {
          // this.contentToSelect = res.data || [];
          let arr = res.data.filter((item) => item.type == this.type &&  this.serviceCost.every( (em) => partyBId != em.partyBId&&em.serialNumber != item.serialNumber      )        )
          this.contentToSelect = arr||[];
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },
    /**
     * 把表格1各种合计项计算一遍
     */
    updateSum() {
      // 先每一个单项合计
      this.updateSum123456();
      // 再1-4
      this.update14();
      // 再5-6
      this.update56();
      // 再1-6
      this.update16();

      // 还要算一下 收集团拨款金额、资金成本
      this.groupAmount = this.sum1_6 ? this.sum1_6.alreadyPay : 0;
      if (
        this.receiptsEarningCost &&
        this.receiptsEarningCost.receiptPriceSum &&
        this.groupAmount &&
        this.formData.loanPct
      ) {
        this.capitalCost = Number(
          (
            ((this.receiptsEarningCost.receiptPriceSum - this.groupAmount) *
              this.formData.loanPct) /
            100
          ).toFixed(2)
        );
      }
    },

    updateSum123456() {
      let sum1 = this.updateSingleSum(this.serviceCost);
      this.serviceCostSum = { ...sum1 };
      let sum2 = this.updateSingleSum(this.materialCost);
      this.materialCostSum = { ...sum2 };
      let sum3 = this.updateSingleSum(this.machineCost);
      this.machineCostSum = { ...sum3 };
      let sum4 = this.updateSingleSum(this.otherDirectCost);
      this.otherDirectCostSum = { ...sum4 };
      let sum5 = this.updateSingleSum56(this.projectManagementCost);
      this.projectManagementCostSum = { ...sum5 };
      let sum6 = this.updateSingleSum56([
        this.equipDeptCost,
        this.facilityDeptCost,
        this.projectDeptCost,
      ]);
      this.sum6 = { ...sum6 };
    },
    update14() {
      let sum = this.updateSum14_56_16([
        this.serviceCostSum,
        this.materialCostSum,
        this.machineCostSum,
        this.otherDirectCostSum,
      ]);
      this.sum1_4 = { ...sum };
    },
    update56() {
      let sum = this.updateSum14_56_16([
        this.projectManagementCostSum,
        this.sum6,
      ]);
      this.sum5_6 = { ...sum };
    },
    update16() {
      let sum = this.updateSum14_56_16([this.sum1_4, this.sum5_6]);
      this.sum1_6 = { ...sum };
    },

    updateSingleSum(arr) {
      let result = {
        settleAmount: 0, //结算金额
        cost: 0, //工程施工成本
        taxBillAmount: 0, // 开具发票含税金额
        noTaxBillAmount: 0, //
        taxNoBillAmount: 0, //未开具发票含税金额,
        noTaxNoBillAmount: 0, //
        alreadyPay: 0, //累计已付款金额
        debtAmount: 0, //尚欠款
        alreadyPayPct: 0, //已付款比例
        thisPay: 0, // 本次拟付款
        thisPayPct: 0, //再付款比例
        actNoTaxAmount: 0, //实际发生金额中的不含税金额.用不到的有也没事
      };
      for (let i = 0; i < arr.length; i++) {
        result.settleAmount += Number(
          isNil(arr[i].settleAmount) ? 0 : arr[i].settleAmount
        );
        result.cost += Number(isNil(arr[i].cost) ? 0 : arr[i].cost);
        result.taxBillAmount += Number(
          isNil(arr[i].taxBillAmount) ? 0 : arr[i].taxBillAmount
        );
        result.noTaxBillAmount += Number(
          isNil(arr[i].noTaxBillAmount) ? 0 : arr[i].noTaxBillAmount
        );
        result.taxNoBillAmount += Number(
          isNil(arr[i].taxNoBillAmount) ? 0 : arr[i].taxNoBillAmount
        );
        result.noTaxNoBillAmount += Number(
          isNil(arr[i].noTaxNoBillAmount) ? 0 : arr[i].noTaxNoBillAmount
        );
        result.alreadyPay += Number(
          isNil(arr[i].alreadyPay) ? 0 : arr[i].alreadyPay
        );
        result.debtAmount += Number(
          isNil(arr[i].debtAmount) ? 0 : arr[i].debtAmount
        );
       result.alreadyPayPct = Number(
          result.settleAmount
            ? ((result.alreadyPay / result.settleAmount) * 100).toFixed(2)
            : 0
        ); //累计已付款/税后合价
        result.thisPay += Number(isNil(arr[i].thisPay) ? 0 : arr[i].thisPay);
        result.thisPayPct = Number(
          result.settleAmount
            ? (
                ((result.thisPay + result.alreadyPay) / result.settleAmount) *
                100
              ).toFixed(2)
            : 0
        ); //（本次拟付款+累计已付款）/税后合价
        let noTaxBillAmount = Number(
          isNil(arr[i].noTaxBillAmount) ? 0 : arr[i].noTaxBillAmount
        );
        let noTaxNoBillAmount = Number(
          isNil(arr[i].noTaxNoBillAmount) ? 0 : arr[i].noTaxNoBillAmount
        );
        result.actNoTaxAmount += Number(
          (noTaxBillAmount + noTaxNoBillAmount).toFixed(2)
        );
      }

      return result;
    },
    // 间接成本的算单个合
    updateSingleSum56(arr) {
      let result = {
        settleAmount: 0, //结算金额
        cost: 0, //工程施工成本
        taxBillAmount: 0, // 开具发票含税金额
        noTaxBillAmount: 0, //
        taxNoBillAmount: 0, //未开具发票含税金额,
        noTaxNoBillAmount: 0, //
        alreadyPay: 0, //累计已付款金额
        debtAmount: 0, //尚欠款
        alreadyPayPct: 0, //已付款比例
        thisPay: 0, // 本次拟付款
        thisPayPct: 0, //再付款比例
        actNoTaxAmount: 0, //实际发生金额中的不含税金额
      };
      for (let i = 0; i < arr.length; i++) {
        result.settleAmount += Number(
          isNil(arr[i].settleAmount) ? 0 : arr[i].settleAmount
        );
        result.cost += Number(isNil(arr[i].cost) ? 0 : arr[i].cost);
        result.taxBillAmount += Number(
          isNil(arr[i].taxBillAmount) ? 0 : arr[i].taxBillAmount
        );
        result.noTaxBillAmount += Number(
          isNil(arr[i].noTaxBillAmount) ? 0 : arr[i].noTaxBillAmount
        );
        result.taxNoBillAmount += Number(
          isNil(arr[i].taxNoBillAmount) ? 0 : arr[i].taxNoBillAmount
        );
        result.noTaxNoBillAmount += Number(
          isNil(arr[i].noTaxNoBillAmount) ? 0 : arr[i].noTaxNoBillAmount
        );
        result.alreadyPay += Number(
          isNil(arr[i].alreadyPay) ? 0 : arr[i].alreadyPay
        );
        result.debtAmount += Number(
          isNil(arr[i].debtAmount) ? 0 : arr[i].debtAmount
        );
        result.alreadyPayPct = Number(
          result.settleAmount
            ? ((result.alreadyPay / result.settleAmount) * 100).toFixed(2)
            : 0
        ); //累计已付款/税后合价
        result.thisPay += Number(isNil(arr[i].thisPay) ? 0 : arr[i].thisPay);
        result.thisPayPct = Number(
          result.settleAmount
            ? (
                ((result.thisPay + result.alreadyPay) / result.settleAmount) *
                100
              ).toFixed(2)
            : 0
        ); //（本次拟付款+累计已付款）/税后合价
        result.actNoTaxAmount += Number(
          isNil(arr[i].noTaxBillAmount) ? 0 : arr[i].noTaxBillAmount
        );
      }
      return result;
    },
    // 算不同部分的和
    updateSum14_56_16(arr) {
      let result = {
        settleAmount: 0, //结算金额
        cost: 0, //工程施工成本
        taxBillAmount: 0, // 开具发票含税金额
        noTaxBillAmount: 0, //
        taxNoBillAmount: 0, //未开具发票含税金额,
        noTaxNoBillAmount: 0, //
        alreadyPay: 0, //累计已付款金额
        debtAmount: 0, //尚欠款
        alreadyPayPct: 0, //已付款比例
        thisPay: 0, // 本次拟付款
        thisPayPct: 0, //再付款比例
        actNoTaxAmount: 0, //实际发生金额中的不含税金额
      };
      for (let i = 0; i < arr.length; i++) {
        result.settleAmount += Number(
          isNil(arr[i].settleAmount) ? 0 : arr[i].settleAmount
        );
        result.cost += Number(isNil(arr[i].cost) ? 0 : arr[i].cost);
        result.taxBillAmount += Number(
          isNil(arr[i].taxBillAmount) ? 0 : arr[i].taxBillAmount
        );
        result.noTaxBillAmount += Number(
          isNil(arr[i].noTaxBillAmount) ? 0 : arr[i].noTaxBillAmount
        );
        result.taxNoBillAmount += Number(
          isNil(arr[i].taxNoBillAmount) ? 0 : arr[i].taxNoBillAmount
        );
        result.noTaxNoBillAmount += Number(
          isNil(arr[i].noTaxNoBillAmount) ? 0 : arr[i].noTaxNoBillAmount
        );
        result.alreadyPay += Number(
          isNil(arr[i].alreadyPay) ? 0 : arr[i].alreadyPay
        );
        result.debtAmount += Number(
          isNil(arr[i].debtAmount) ? 0 : arr[i].debtAmount
        );
        result.alreadyPayPct = Number(
          result.settleAmount
            ? ((result.alreadyPay / result.settleAmount) * 100).toFixed(2)
            : 0
        ); //累计已付款/税后合价
        result.thisPay += Number(isNil(arr[i].thisPay) ? 0 : arr[i].thisPay);
        result.thisPayPct = Number(
          result.settleAmount
            ? (
                ((result.thisPay + result.alreadyPay) / result.settleAmount) *
                100
              ).toFixed(2)
            : 0
        ); //（本次拟付款+累计已付款）/税后合价

        let actNoTaxAmount = Number(
          isNil(arr[i].actNoTaxAmount) ? 0 : arr[i].actNoTaxAmount
        );
        result.actNoTaxAmount += Number(actNoTaxAmount.toFixed(2));
      }
      return result;
    },
    provisionalAmount_actTaxAmount_changed(currentValue) {
      // console.log("暂定金-实际-含税金额变了", currentValue);
      currentValue = currentValue || 0;
      if (this.receiptsEarningCost) {
        const { taxRate = 0 } = this.receiptsEarningCost;
        this.provisionalAmount_actNoTaxAmount = Number(
          (currentValue / (1 + taxRate / 100)).toFixed(2)
        );
      } else {
        this.provisionalAmount_actNoTaxAmount = 0;
      }
      this.updateContractTotalIncomeAmount12();
      this.updateContractGrossProfit();
      this.updateContractGrossProfitRate();
      this.formatTableData2();
    },
    listCheckAmount_actTaxAmount_changed(currentValue) {
      currentValue = currentValue || 0;
      if (this.receiptsEarningCost) {
        const { taxRate = 0 } = this.receiptsEarningCost;
        this.listCheckAmount_actNoTaxAmount = Number(
          (currentValue / (1 + taxRate / 100)).toFixed(2)
        );
      } else {
        this.listCheckAmount_actNoTaxAmount = 0;
      }
      this.formatTableData2();
    },
    contractPriceIndexAmount_actTaxAmount_changed(currentValue) {
      // console.log("合同物价指数金额-实际-含税金额变了");
      currentValue = currentValue || 0;
      if (this.receiptsEarningCost) {
        const { taxRate = 0 } = this.receiptsEarningCost;
        this.contractPriceIndexAmount_actNoTaxAmount = Number(
          (currentValue / (1 + taxRate / 100)).toFixed(2)
        );
      } else {
        this.contractPriceIndexAmount_actNoTaxAmount = 0;
      }
      this.updateContractTotalIncomeAmount12();
      this.updateContractGrossProfit();
      this.updateContractGrossProfitRate();
      this.formatTableData2();
    },
    contractTotalIncomeAmount_actTaxAmount_changed(currentValue) {
      // console.log("合同总收入金额，实际发生，含税，变了", currentValue);
      currentValue = currentValue || 0;
      if (this.receiptsEarningCost) {
        const { taxRate = 0 } = this.receiptsEarningCost;
        this.contractTotalIncomeAmount_actNoTaxAmount = Number(
          (currentValue / (1 + taxRate / 100)).toFixed(2)
        );
      } else {
        this.contractTotalIncomeAmount_actNoTaxAmount = 0;
      }

      //   "-- 重新计算 合同总收入金额-实际发生金额-不含税金额之后，就要重新计算合同毛利和合同毛利率了"
      this.updateContractGrossProfit();
      this.updateContractGrossProfitRate();
      this.formatTableData2();
    },
    indirectInputChange() {
      this.updateIndirectCostSum12();
      this.updateTotalContractCost();
      this.updateContractGrossProfit();
      this.updateContractGrossProfitRate();
      this.formatTableData2();
    },
    updateIndirectCostSum12() {
      // console.log("updateIndirectCostSum, 4个数据都要算");
      this.indirectCostSum_budgetTaxAmount =
        Number(this.projectManagementAmount_budgetTaxAmount || 0) +
        Number(this.otherIndirectAmount_budgetTaxAmount || 0);
      this.indirectCostSum_budgetNoTaxAmount =
        Number(this.projectManagementAmount_budgetNoTaxAmount || 0) +
        Number(this.otherIndirectAmount_budgetNoTaxAmount || 0);

      this.indirectCostSum_settleAmount =
        Number(this.projectManagementAmount_actTaxAmount || 0) +
        Number(this.otherIndirectAmount_actTaxAmount || 0);

      this.indirectCostSum_actNoTaxAmount =
        Number(this.projectManagementAmount_actNoTaxAmount || 0) +
        Number(this.otherIndirectAmount_actNoTaxAmount || 0);
    },
    /**
     * 计算合同总成本
     */
    updateTotalContractCost() {
      this.totalContractCost_budgetTaxAmount =
        Number(this.directCostData.sumVO.expectTaxAmount || 0) +
        Number(this.indirectCostSum_budgetTaxAmount || 0);
      this.totalContractCost_budgetNoTaxAmount =
        Number(this.directCostData.sumVO.expectNoTaxAmount || 0) +
        Number(this.indirectCostSum_budgetNoTaxAmount || 0);

      this.totalContractCost_actTaxAmount =
        Number(this.directCostData.sumVO.actTaxAmount || 0) +
        Number(this.indirectCostSum_settleAmount || 0);

      this.totalContractCost_actNoTaxAmount =
        Number(this.directCostData.sumVO.actNoTaxAmount || 0) +
        Number(this.indirectCostSum_actNoTaxAmount || 0);
    },
    /**
     * 计算合同毛利
     */
    updateContractGrossProfit() {
      // 一共四列，每列都是当前列合同总收入金额-合同总成本合计

      this.contractGrossProfit_budgetTaxAmount = Number(
        Number(this.contractTotalIncomeAmount_budgetTaxAmount) -
          Number(this.totalContractCost_budgetTaxAmount)
      );

      this.contractGrossProfit_budgetNoTaxAmount = Number(
        Number(this.contractTotalIncomeAmount_budgetNoTaxAmount) -
          Number(this.totalContractCost_budgetNoTaxAmount)
      );

      this.contractGrossProfit_actTaxAmount = Number(
        Number(this.contractTotalIncomeAmount_actTaxAmount) -
          Number(this.totalContractCost_actTaxAmount)
      );

      this.contractGrossProfit_actNoTaxAmount = Number(
        Number(this.contractTotalIncomeAmount_actNoTaxAmount) -
          Number(this.totalContractCost_actNoTaxAmount)
      );
    },
    updateContractGrossProfitRate() {
      if (
        this.contractGrossProfit_budgetTaxAmount &&
        this.contractTotalIncomeAmount_budgetTaxAmount
      ) {
        this.contractGrossProfitRate_budgetTaxAmount =
          (Number(this.contractGrossProfit_budgetTaxAmount) /
            Number(this.contractTotalIncomeAmount_budgetTaxAmount)) *
          100;
      } else {
        this.contractGrossProfitRate_budgetTaxAmount = 0;
      }
      if (
        this.contractGrossProfit_budgetNoTaxAmount &&
        this.contractTotalIncomeAmount_budgetNoTaxAmount
      ) {
        this.contractGrossProfitRate_budgetNoTaxAmount =
          (Number(this.contractGrossProfit_budgetNoTaxAmount) /
            Number(this.contractTotalIncomeAmount_budgetNoTaxAmount)) *
          100;
      } else {
        this.contractGrossProfitRate_budgetNoTaxAmount = 0;
      }
      if (
        this.contractGrossProfit_actTaxAmount &&
        this.contractTotalIncomeAmount_actTaxAmount
      ) {
        this.contractGrossProfitRate_actTaxAmount =
          (Number(this.contractGrossProfit_actTaxAmount) /
            Number(this.contractTotalIncomeAmount_actTaxAmount)) *
          100;
      } else {
        this.contractGrossProfitRate_actTaxAmount = 0;
      }
      if (
        this.contractGrossProfit_actNoTaxAmount &&
        this.contractTotalIncomeAmount_actNoTaxAmount
      ) {
        this.contractGrossProfitRate_actNoTaxAmount =
          (Number(this.contractGrossProfit_actNoTaxAmount) /
            Number(this.contractTotalIncomeAmount_actNoTaxAmount)) *
          100;
      } else {
        this.contractGrossProfitRate_actNoTaxAmount = 0;
      }
    },
    //处理基本信息表格数据
    handleData(reject) {
      function strExist(value) {
        return value != undefined && value != null && value != "";
      }
      function strNotExist(value) {
        return value === undefined || value === null || value === "";
      }
      for (let i = 0; i < this.serviceCost.length; i++) {
        let item = this.serviceCost[i];
        if (strExist(item.settleAmount) && strExist(item.cost)) {
          if( strNotExist(item.taxBillAmount))
          {
            this.$message.warning("劳务费开具发票-含税金额未填写");
            reject(false);
            return;
          }else if(strNotExist(item.noTaxBillAmount))
          {
            this.$message.warning("劳务费开具发票-不含税金额未填写");
            reject(false);
            return;
          }else if(strNotExist(item.taxRateCurrent))
          {
            this.$message.warning("劳务费未开具发票-暂行税率未填写");
            reject(false);
            return;
          }
          // if (
          //   strNotExist(item.taxBillAmount) ||
          //   strNotExist(item.noTaxBillAmount) ||
          //   strNotExist(item.taxRateCurrent)
          // ) {
          //   this.$message.warning("劳务费开具发票、未开具发票相关金额未填写");
          //   reject(false);
          //   return;
          // }
        }
      }
      for (let i = 0; i < this.machineCost.length; i++) {
        let item = this.machineCost[i];
        if (strExist(item.settleAmount) && strExist(item.cost)) {
          if( strNotExist(item.taxBillAmount))
          {
            this.$message.warning("机械费开具发票-含税金额未填写");
            reject(false);
            return;
          }else if(strNotExist(item.noTaxBillAmount))
          {
            this.$message.warning("机械费开具发票-不含税金额未填写");
            reject(false);
            return;
          }else if(strNotExist(item.taxRateCurrent))
          {
            this.$message.warning("机械费未开具发票-暂行税率未填写");
            reject(false);
            return;
          }
        }
      }
      for (let i = 0; i < this.materialCost.length; i++) {
        let item = this.materialCost[i];
        if (strExist(item.settleAmount) && strExist(item.cost)) {
          if( strNotExist(item.taxBillAmount))
          {
            this.$message.warning("材料费开具发票-含税金额未填写");
            reject(false);
            return;
          }else if(strNotExist(item.noTaxBillAmount))
          {
            this.$message.warning("材料费开具发票-不含税金额未填写");
            reject(false);
            return;
          }else if(strNotExist(item.taxRateCurrent))
          {
            this.$message.warning("材料费未开具发票-暂行税率未填写");
            reject(false);
            return;
          }
        }
      }
      for (let i = 0; i < this.otherDirectCost.length; i++) {
        let item = this.otherDirectCost[i];
        if (strExist(item.settleAmount) && strExist(item.cost)) {
          if( strNotExist(item.taxBillAmount))
          {
            this.$message.warning("其它直接费开具发票-含税金额未填写");
            reject(false);
            return;
          }else if(strNotExist(item.noTaxBillAmount))
          {
            this.$message.warning("其它直接费开具发票-不含税金额未填写");
            reject(false);
            return;
          }else if(strNotExist(item.taxRateCurrent))
          {
            this.$message.warning("其它直接费未开具发票-暂行税率未填写");
            reject(false);
            return;
          }
        }
      }
      // let item=this.projectManagementCost[0];
      //   if (strExist(item.settleAmount) && strExist(item.cost)) {
      //     if (
      //       strNotExist(item.taxBillAmount) ||
      //       strNotExist(item.noTaxBillAmount) ||
      //       strNotExist(item.taxRateCurrent)
      //     ) {
      //       this.$message.warning("项目管理费开具发票、未开具发票相关金额未填写");
      //       reject(false);
      //       return;
      //     }
      //   }
      //  item=this.equipDeptCost;  //设备物资部
      //   if (strExist(item.settleAmount) && strExist(item.cost)) {
      //     if (
      //       strNotExist(item.taxBillAmount) ||
      //       strNotExist(item.noTaxBillAmount) ||
      //       strNotExist(item.taxRateCurrent)
      //     ) {
      //       this.$message.warning("设备物资部开具发票、未开具发票相关金额未填写");
      //       reject(false);
      //       return;
      //     }
      //   }
      //   item=this.facilityDeptCost;  //设施场
      //   if (strExist(item.settleAmount) && strExist(item.cost)) {
      //     if (
      //       strNotExist(item.taxBillAmount) ||
      //       strNotExist(item.noTaxBillAmount) ||
      //       strNotExist(item.taxRateCurrent)
      //     ) {
      //       this.$message.warning("设施场开具发票、未开具发票相关金额未填写");
      //       reject(false);
      //       return;
      //     }
      //   }
      //   item=this.projectDeptCost;  //工程处
      //   if (strExist(item.settleAmount) && strExist(item.cost)) {
      //     if (
      //       strNotExist(item.taxBillAmount) ||
      //       strNotExist(item.noTaxBillAmount) ||
      //       strNotExist(item.taxRateCurrent)
      //     ) {
      //       this.$message.warning("工程处开具发票、未开具发票相关金额未填写");
      //       reject(false);
      //       return;
      //     }
      //   }
    },
    /**
     * 点击提交数据
     */
    submitData(val) {
      let infoPromise = new Promise((resolve, reject) => {
        if (val) {
          if(!this.formData.projectId){
            this.$message.warning("请选择项目名称");
          reject(false);
          return; 
          }
          resolve(true);
        }else{
          this.$refs["formRef1"].validate((valid) => {
          if (valid) {
            this.handleData(reject);
            resolve(true);
          } else {
            reject(false);
          }
        });
        }
       
      });

      let approvePromise = new Promise((resolve, reject) => {
        let pass = true;
        if (this.approveList.length == 0&& !val) {
          this.$message.warning("请先配置审批流程");
          reject(false);
        }
        for (let i = 0; i < this.approveList.length; i++) {
          if (!!this.approveList[i].approveUserId == false) {
            // 还没选定人
            pass = false;
            break;
          }
        }

        if (pass == false&& !val) {
          this.$message.warning("请配置审批流程");
          reject(false);
        } else {
          resolve(true);
        }
      });

      Promise.all([infoPromise, approvePromise]).then(() => {
        let params = {};
        params.isTempSave = val;
        params.deptId = this.formData.deptId;
        params.projectId = this.formData.projectId;
        params.loanPct = this.formData.loanPct;
        params.expectIncomePct = this.formData.expectIncomePct;
        let dept = (this.deptListForSelect || []).find(
          (item) => item.applyDeptId == params.deptId
        );
        params.deptName = dept ? dept.applyDeptName : "";
        let project = (this.projectListForSelect || []).find(
          (item) => item.id == params.projectId
        );
        params.projectName = project ? project.name : "";

        function strExist(value) {
          return value != undefined && value != null && value != "";
        }

        // 表1
        // params.serviceCost = this.serviceCost.filter(
        //   (item) => strExist(item.partyB) && strExist(item.contractContent)
        // ); // 劳务费
        // params.materialCost = this.materialCost.filter(
        //   (item) => strExist(item.partyB) && strExist(item.contractContent)
        // ); // 材料费
        // params.machineCost = this.machineCost.filter(
        //   (item) => strExist(item.partyB) && strExist(item.contractContent)
        // ); // 机械费
        // params.otherDirectCost = this.otherDirectCost.filter(
        //   (item) => strExist(item.partyB) && strExist(item.contractContent)
        // ); // 其他直接费

        params.serviceCost = this.serviceCost;
        params.materialCost = this.materialCost;
        params.machineCost = this.machineCost;
        params.otherDirectCost = this.otherDirectCost;

        if (this.directCostData) {
          if (this.directCostData.laborVO) {
            params.serviceAmount = {
              contractAmount: this.directCostData.laborVO.contractAmount,
              budgetTaxAmount: this.directCostData.laborVO.expectTaxAmount,
              budgetNoTaxAmount: this.directCostData.laborVO.expectNoTaxAmount,
              actTaxAmount: this.directCostData.laborVO.actTaxAmount,
              actNoTaxAmount: this.directCostData.laborVO.actNoTaxAmount,
            };
          }
          if (this.directCostData.machineVO) {
            params.machineAmount = {
              contractAmount: this.directCostData.machineVO.contractAmount,
              budgetTaxAmount: this.directCostData.machineVO.expectTaxAmount,
              budgetNoTaxAmount:
                this.directCostData.machineVO.expectNoTaxAmount,
              actTaxAmount: this.directCostData.machineVO.actTaxAmount,
              actNoTaxAmount: this.directCostData.machineVO.actNoTaxAmount,
            };
          }
          if (this.directCostData.materialVO) {
            params.materialAmount = {
              contractAmount: this.directCostData.materialVO.contractAmount,
              budgetTaxAmount: this.directCostData.materialVO.expectTaxAmount,
              budgetNoTaxAmount:
                this.directCostData.materialVO.expectNoTaxAmount,
              actTaxAmount: this.directCostData.materialVO.actTaxAmount,
              actNoTaxAmount: this.directCostData.materialVO.actNoTaxAmount,
            };
          }
          if (this.directCostData.othersVO) {
            params.otherDirectAmount = {
              contractAmount: this.directCostData.othersVO.contractAmount,
              budgetTaxAmount: this.directCostData.othersVO.expectTaxAmount,
              budgetNoTaxAmount: this.directCostData.othersVO.expectNoTaxAmount,
              actTaxAmount: this.directCostData.othersVO.actTaxAmount,
              actNoTaxAmount: this.directCostData.othersVO.actNoTaxAmount,
            };
          }

          if (this.directCostData.sumVO) {
            params.tableTwoDirectTotal = {
              contractAmount: this.directCostData.sumVO.contractAmount,
              budgetTaxAmount: this.directCostData.sumVO.expectTaxAmount,
              budgetNoTaxAmount: this.directCostData.sumVO.expectNoTaxAmount,
              actTaxAmount: this.directCostData.sumVO.actTaxAmount,
              actNoTaxAmount: this.directCostData.sumVO.actNoTaxAmount,
            };
          }
        }

        params.projectManagementCost = this.projectManagementCost[0]; //项目管理费
        params.equipDeptCost = this.equipDeptCost; // 设备物资部
        params.facilityDeptCost = this.facilityDeptCost; // 设施场
        params.projectDeptCost = this.projectDeptCost; //  工程处
        // 表2
        params.provisionalAmount = {
          actTaxAmount: this.provisionalAmount_actTaxAmount,
        }; //暂定金(变更金额)	-实际发生金额	-含税金额
        params.listCheckAmount = {
          actTaxAmount: this.listCheckAmount_actTaxAmount,
        }; //清单复核金额	-实际发生金额	-含税金额
        params.contractPriceIndexAmount = {
          actTaxAmount: this.contractPriceIndexAmount_actTaxAmount,
        }; //合同物价指数金额	-实际发生金额	-含税金额
        params.contractTotalIncomeAmount = {
          actTaxAmount: this.contractTotalIncomeAmount_actTaxAmount,
        }; //合同总收入金额	-实际发生金额	-含税金额

        //间接成本-管理费用-预算金额	-含税金额
        params.projectManagementAmount = {
          budgetTaxAmount: this.projectManagementAmount_budgetTaxAmount,
          budgetNoTaxAmount: this.projectManagementAmount_budgetNoTaxAmount,
          actTaxAmount: this.projectManagementAmount_actTaxAmount,
          actNoTaxAmount: this.projectManagementAmount_actNoTaxAmount,
        };
        //间接成本-其他-预算金额	-含税金额
        params.otherIndirectAmount = {
          budgetTaxAmount: this.otherIndirectAmount_budgetTaxAmount,
          budgetNoTaxAmount: this.otherIndirectAmount_budgetNoTaxAmount,
          actTaxAmount: this.otherIndirectAmount_actTaxAmount,
          actNoTaxAmount: this.otherIndirectAmount_actNoTaxAmount,
        };
        if (!val) {
        // 选了项目部和项目名称之后才有receiptsEarningCost
        if (!this.receiptsEarningCost || !this.sum1_6) {
          this.$alert("合同金额不能小于工程施工成本", "提示");
          return;
        }

        if (!this.receiptsEarningCost.contractPrice || !this.sum1_6.cost) {
          this.$alert("合同金额不能小于工程施工成本", "提示");
          return;
        }

        if (this.receiptsEarningCost.contractPrice < this.sum1_6.cost) {
          this.$alert("合同金额不能小于工程施工成本", "提示");
          return;
        }
      }
        params.id = this.id;
        editEarningCost(params)
          .then((res) => {
            if (res.code == Constants.Code_OK) {
              const itemId = res.data;
              if (val) {
                //暂存审批流
                this.tempSaveApprove(itemId,params.projectName);
                return;
              }
              let __params = {
                approveClass: "EARNING_COST",
                approveProcessDtoList: this.approveList,
                itemId: itemId,
                approveStatusEnum: "UNDERAPLLY",
                projectId: this.formData.projectId,
                itemName: `${sessionStorage.getItem("name")}关于${
                  this.receiptsEarningCost.belongYear
                } ${this.receiptsEarningCost.processStatusDisplayName || ""} ${
                  params.projectName
                }的收入记录申请`,
              };
              let apiName=this.flag?updateApproveProcessStatusService:createApproveProcessServiceApi
              apiName(__params).then((res) => {
                // "---创建审批流回来
                if (res.code == Constants.Code_OK) {
                  this.$alert("提交成功", "提示");
                  this.closePage();
                } else if (res.code == Constants.Code_Err) {
                  this.$alert(res.msg, "提示");
                } else {
                  this.$alert(Constants.Err_Msg, "提示");
                }
              });
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
     //暂存审批流
     tempSaveApprove(itemId,projectName) {
      if (this.approveList.length == 0) {
        this.$message.success("保存成功", "提示");
        // 如果approveList长度是0，那代表还没有选定项目类型，暂存不保存审批流
        this.closePage();
        return;
      }
      let pass = true;
      for (let i = 0; i < this.approveList.length; i++) {
        if (!this.approveList[i].approveUserId) {
          // 还没选定人
          pass = false;
          break;
        }
      }
      //未选择审批人，不保存审批流
      if (pass == false) {
        this.$message.success("保存成功", "提示");
        this.closePage();
        return;
      }
     let __params = {
        approveClass: "EARNING_COST",
        approveProcessDtoList: this.approveList,
        itemId: itemId,
        approveStatusEnum: "READY",
        projectId: this.formData.projectId,
        itemName: `${sessionStorage.getItem("name")}关于${
          this.receiptsEarningCost.belongYear
        } ${this.receiptsEarningCost.processStatusDisplayName || ""} ${
          projectName
        }的收入记录申请`,
      };

      createApproveProcessServiceApi(__params).then((res) => {
        //---创建审批流回来"
        if (res.code == Constants.Code_OK) {
          this.$message.success("保存成功", "提示");
          this.closePage();
        } else if (res.code == Constants.Code_Err) {
          this.$alert(res.msg, "提示");
        } else {
          this.$alert(Constants.Err_Msg, "提示");
        }
      });
    },
    /**
     * 更新 合同总收入金额	1，2
     */
    updateContractTotalIncomeAmount12() {
      if (this.receiptsEarningCost) {
        if (!this.receiptsEarningCost.processStatusDisplayName) {
          // 没有这个状态的情况下,如果有审计金额,那就用.如果没有,那就用合同金额.再没有就只能是0了
          this.contractTotalIncomeAmount_budgetTaxAmount =
            this.receiptsEarningCost.auditAmount ||
            this.receiptsEarningCost.contractPrice ||
            0;
        } else if (
          this.receiptsEarningCost.processStatusDisplayName == "已审计"
        ) {
          this.contractTotalIncomeAmount_budgetTaxAmount = Number(
            this.auditAmount_budgetTaxAmount || 0
          );
        } else {
          this.contractTotalIncomeAmount_budgetTaxAmount =
            this.receiptsEarningCost.auditAmount ||
            this.receiptsEarningCost.contractPrice ||
            0;
        }
      } else {
        this.contractTotalIncomeAmount_budgetTaxAmount = 0;
      }

      if (this.receiptsEarningCost) {
        const { taxRate = 0 } = this.receiptsEarningCost;
        this.contractTotalIncomeAmount_budgetNoTaxAmount =
          this.contractTotalIncomeAmount_budgetTaxAmount / (1 + taxRate / 100);
      } else {
        this.contractTotalIncomeAmount_budgetNoTaxAmount = 0;
      }
    },
    updateIndirectCostSum34() {
      this.indirectCostSum_settleAmount = Number(
        (
          (this.projectManagementCostSum &&
          this.projectManagementCostSum.settleAmount
            ? this.projectManagementCostSum.settleAmount
            : 0) +
          (this.sum6 && this.sum6.settleAmount ? this.sum6.settleAmount : 0)
        ).toFixed(2)
      );
      this.indirectCostSum_actNoTaxAmount = Number(
        (
          (this.projectManagementCostSum &&
          this.projectManagementCostSum.actNoTaxAmount
            ? this.projectManagementCostSum.actNoTaxAmount
            : 0) +
          (this.sum6 && this.sum6.actNoTaxAmount ? this.sum6.actNoTaxAmount : 0)
        ).toFixed(2)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.create-earning-item {
  background: white;
  margin-bottom: 16px;
}

.el-tab-pane {
  margin-top: 20px;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

/deep/ .el-form-item__content {
  display: flex;

  .el-input {
    flex: 1;
  }

  .el-button {
    margin-left: 10px;
    height: fit-content;
  }
}

.wrapper {
  // padding: 16px;
  box-sizing: border-box;
}

/deep/.el-form-item {
  width: 100%;
}
/deep/.el-form-item__content {
  width: calc(100% - 200px);
}

/deep/.el-select {
  width: 100%;
}

/deep/.el-input-number {
  width: 100% !important;

  input {
    text-align: left;
  }
}

.form-wrapper {
  margin-bottom: 30px;
  /deep/.el-input-number {
    input {
      text-align: left !important;
    }
  }
}

.table-wrapper {
  margin-left: 20px;
  padding-bottom: 30px;
}
</style>
